import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import loader from "../../assets/Images/loader.gif";
//import { useParams } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// const optionBusiness = ["Select Business Segment ","Business"];
const optionSubBusiness = [
  { value: "0", label: "Select Sub Business Segment" },
  { value: "Connectivity Solution", label: "Connectivity Solution" },
  { value: "Data Centre Products", label: "Data Centre Products" },
  { value: "Internet Service", label: "Internet Service" },
  { value: "SDWAN", label: "SDWAN" },
  { value: "SIP-Trunk", label: "SIP-Trunk" },
  { value: "VOIP", label: "VOIP" },
  { value: "Video Analytics", label: "Video Analytics" },
];
const optionCustomerSeg = [
  { label: "Select Customer Segment", value: "0" },
  { label: "SDWAN", value: "111260004" },
  { label: "SMB", value: "111260000" },
  { label: "Media", value: "111260001" },
  { label: "LA", value: "111260002" },
  { label: "SP", value: "111260003" },
];
const optionSalutation = [
  { label: "Select Salutation", value: "0" },
  { label: "Mr.", value: "1" },
  { label: "Mrs.", value: "2" },
  { label: "Miss", value: "3" },
];
//const optionRelationship = ["Select Relationship"];
const optionLeadChannel = [
  { label: "Select Channel", value: "" },
  { label: "FFA APP", value: "FFA App" },
  { label: "Self Lead", value: "Self Lead" },
  { label: "CXM Team", value: "CXM Team" },
  { label: "Call/SMS-Inbound", value: "Call/SMS-Inbound" },
  { label: "Caretel", value: "Caretel" },
  { label: "CM Outbound", value: "CM Outbound" },
  { label: "Email/Email Campaigns", value: "Email/Email Campaigns" },
  { label: "Inside Sales", value: "Inside Sales" },
  { label: "Inside Sales-QC", value: "Inside Sales-QC" },
  { label: "Kaizala", value: "Kaizala" },
  { label: "NetOps Channel", value: "NetOps Channel" },
  { label: "Online CAF", value: "Online CAF" },
  { label: "Outbound Call", value: "Outbound Call" },
  { label: "Paid Campaign/Activity", value: "Paid Campaign/Activity" }, {
    label: "Promotion/BTL/ATL/Events/Sponsorship/Visibility Activity",
    value: "Promotion/BTL/ATL/Events/Sponsorship/Visibility Activity",
  },
  { label: "Self Care Portal", value: "Self Care Portal" },
  { label: "Unify Churned", value: "Unify Churned" },
  { label: "Web Campaign", value: "Web Campaign" },
];
const optionChannelPartner = [{ label: "", value: "" }];
const optionCountry = [{ label: "India", value: "10001" }];
const optionCountryOne = [{ label: "India", value: "10001" },];

const optionState = [
  { name: "Select State", code: "" },
  { name: "Andhra Pradesh", code: "100009" },
  { name: "Jharkhand", code: "100030" },
  { name: "Bihar", code: "100021" },
  { name: "Delhi", code: "100004" },
  { name: "Gujarat", code: "100015" },
  { name: "Haryana", code: "100008" },
  { name: "Jammu and Kashmir", code: "100011" },
  { name: "Karnataka", code: "100007" },
  { name: "Kerala", code: "100012" },
  { name: "Madhya Pradesh", code: "100014" },
  { name: "Maharashtra", code: "100002" },
  { name: "Odisha", code: "100026" },
  { name: "Other*", code: "100017" },
  { name: "Punjab", code: "100025" },
  { name: "Rajasthan", code: "100010" },
  { name: "Tamil Nadu", code: "100003" },
  { name: "Telangana", code: "100023" },
  { name: "Uttar Pradesh", code: "100006" },
  { name: "Uttarakhand", code: "100016" },
  { name: "West Bengal", code: "100013" },
  { name: "Goa", code: "100028" },
];
const optionStateOne = [
  { name: "Select State", code: "" },
  { name: "Andhra Pradesh", code: "100009" },
  { name: "Bihar", code: "100021" },
  { name: "Delhi", code: "100004" },
  { name: "Gujarat", code: "100015" },
  { name: "Haryana", code: "100008" },
  { name: "Jammu and Kashmir", code: "100011" },
  { name: "Karnataka", code: "100007" },
  { name: "Kerala", code: "100012" },
  { name: "Madhya Pradesh", code: "100014" },
  { name: "Maharashtra", code: "100002" },
  { name: "Odisha", code: "100026" },
  { name: "Other*", code: "100017" },
  { name: "Punjab", code: "100025" },
  { name: "Rajasthan", code: "100010" },
  { name: "Tamil Nadu", code: "100003" },
  { name: "Telangana", code: "100023" },
  { name: "Uttar Pradesh", code: "100006" },
  { name: "Uttarakhand", code: "100016" },
  { name: "West Bengal", code: "100013" },
  { name: "Goa", code: "100028" },
];


const firmType = [
  { label: "Select Firm Type", value: "0" },
  { label: "Proprietorship", value: "1" },
  { label: "Partnership", value: "2" },
  { label: "Pvt Ltd", value: "3" },
  { label: "Ltd", value: "4" },
  { label: "Trust", value: "5" },
  { label: "Individual", value: "6" },
  { label: "LLP", value: "7" },
]

const media = [
  { label: "Fibre", value: "1" },
  { label: "RF", value: "2" },
]
const ExServiceProviderOne = [
  { label: "Select Service Provider 1", value: "0" },
  { label: "Jio", value: "111260000" },
  { label: "ACT Fibernet", value: "569480014" },
  { label: "N.A", value: "569480012" },
  { label: "Others", value: "569480013" },
  { label: "Airtel", value: "569480000" },
  { label: "Aircel", value: "569480002" },
  { label: "BSNL", value: "569480003" },
  { label: "Hathway", value: "569480004" },
  { label: "MTNL", value: "569480005" },
  { label: "Nextra", value: "569480006" },
  { label: "Reliance Communications", value: "569480007" },
  { label: "Sify", value: "569480008" },
  { label: "Tata Communications", value: "569480009" },
  { label: "Tata DOCOMO", value: "569480010" },
  { label: "Tikona Infinet", value: "569480011" },
  { label: "Vodafone", value: "569480001" },
]
const ExServiceProviderTwo = [
  { label: "Select Service Provider 2", value: "0" },
  { label: "Jio", value: "111260000" },
  { label: "ACT Fibernet", value: "569480014" },
  { label: "N.A", value: "569480012" },
  { label: "Others", value: "569480013" },
  { label: "Airtel", value: "569480000" },
  { label: "Aircel", value: "569480002" },
  { label: "BSNL", value: "569480003" },
  { label: "Hathway", value: "569480004" },
  { label: "MTNL", value: "569480005" },
  { label: "Nextra", value: "569480006" },
  { label: "Reliance Communications", value: "569480007" },
  { label: "Sify", value: "569480008" },
  { label: "Tata Communications", value: "569480009" },
  { label: "Tata DOCOMO", value: "569480010" },
  { label: "Tikona Infinet", value: "569480011" },
  { label: "Vodafone", value: "569480001" },
]
const optionDataCenter = [
  { label: "Select Option", value: "" },
  { label: "Yes", value: "true" },
  { label: "No", value: "false" }
]
const optionInterestedFirewall = [
  { label: "Select Option", value: "" },
  { label: "Yes", value: "true" },
  { label: "No", value: "false" }
]
const optionInterestedVPN = [
  { label: "Select Option", value: "" },
  { label: "Yes", value: "true" },
  { label: "No", value: "false" }
]
const optionServiceFromServiceProvider1 = [
  { label: "Select Existing Service Provider", value: "" },
  { label: "Internet", value: "569480000" },
  { label: "Data Center Services", value: "569480001" },
  { label: "OIP Services", value: "569480002" },
  { label: "Other Services", value: "569480003" }
]

const optionServiceFromServiceProvider2 = [
  { label: "Select Existing Service Provider", value: "" },
  { label: "Internet", value: "569480000" },
  { label: "Data Center Services", value: "569480001" },
  { label: "OIP Services", value: "569480002" },
  { label: "Other Services", value: "569480003" }
]

const optionInterestedVOIP = [
  { label: "Select Option", value: "" },
  { label: "Yes", value: "true" },
  { label: "No", value: "false" }
]

const optionInterestedManageWiFi = [
  { label: "Select Option", value: "" },
  { label: "Yes", value: "true" },
  { label: "No", value: "false" }
]
const optionFirewall = [
  { label: "Select Option", value: "" },
  { label: "Yes", value: "True" },
  { label: "No", value: "False" }
]
const optionIsMultilocationCust = [
  { label: "Select Option", value: "" },
  { label: "Yes", value: "True" },
  { label: "No", value: "False" }
]
const optionPaymentMode = [
  { label: "Select Option", value: "" },
  { label: "Capex", value: "Capex" },
  { label: "Opex", value: "Opex" }
];
const optionExistingServProvInfra = [
  { label: "Select Option", value: "" },
  { label: "OEM", value: "OEM" },
  { label: "System Integrator", value: "System Integrator" },
  { label: "Other", value: "Other" }
];
const optionQualify = [
  // { name: "Disqualify", code: "" },
  { name: "Not Interested", code: "569480000" },
  { name: "Delay in Response", code: "569480002" },
  { name: "Pricing issue", code: "569480003 " },
  { name: "Location Is Non-RFS", code: " 569480004" },
  { name: "Existing Customer", code: "569480007 " },
  { name: "Customer Is defaulter", code: "569480008" },
  { name: "Broadband/Home user", code: "569480010" },
  { name: "Duplicate Lead", code: "569480011" },
  { name: "Incomplete information", code: "569480012 " },
  { name: "Wrong Number", code: "569480014 " },
  { name: "Not Contactable", code: "569480015" },
  { name: "Language Barrier", code: "569480016" },
];

const LeadDetailsForm = () => {
  const topicInputRef = useRef(null);
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      // This line disable the blue border
      boxShadow: "none",
    }),
  };

  const [loaders, setLoaders] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeForm, setActiveForm] = useState("form1");
  const [userLeadDataRaw, setUseSameDataRaw] = useState({});
  const [userLeadData, setUserLeadData] = useState({
    topic: "",
    leadId: "",
    PersonName: "",
    mobileNo: "",
    email: "",
    leadName: "",
    companyName: "",
    specifyBuilding: "",
    specifyBuildingOne: "",
    specifyArea: "",
    specifyAreaOne: "",
    buildingNum: "",
    buildingNumOne: "",
    block: "",
    floor: "",
    pin: "",
    blockOne: "",
    floorOne: "",
    pinOne: "",
    jobTitle: "",
    onFirewall: "",
    howManyLocations: "",
    actualContract: "",
    detailServProvInfra: "",
    targetInstallationPeriod: "",
    contractExpDate: "",
    remark: "",
    specifyLeadSource : "",
  });
  const [currentWorkLocations, setCurrentWorkLocations] = useState([]);
  const [selectCurrentWorkLocation, setSelectCurrentWorkLocation] =
    useState("");
  const [selectCity, setSelectCity] = useState("");
  const [cityType, setCityType] = useState([]);
  const [cityTypeOne, setCityTypeOne] = useState([]);
  const [selectCityOne, setSelectCityOne] = useState("");

  const [selectState, setSelectState] = useState("");
  const [selectStateOne, setSelectStateOne] = useState("");
  const [areaList, setAreaList] = useState([]);
  const [selectArea, setSelectArea] = useState("");
  const [selectAreaOne, setSelectAreaOne] = useState("");

  const [buildingList, setBuildingList] = useState([]);
  const [selectBuilding, setSelectBuilding] = useState("");
  const [selectBuildingOne, setSelectBuildingOne] = useState("");
  const [companyOptions, setCompanyOptions] = useState([]);
  const [groupOptions, setGroupOptions] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [leadName, setLeadName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [relationshipOptions, setRelationshipOptions] = useState([]);
  const [selectRelationship, setSelectRelationship] = useState("");
  // const [companyId, setCompanyId] = useState("");
  // const [selectBusiness, setSelectBusiness] = useState("");
  const [selectSubBusiness, setSelectSubBusiness] = useState(optionSubBusiness[0]);
  const [selectCustomerSeg, setSelectCustomerSeg] = useState(optionCustomerSeg[0]);
  const [selectSalutation, setSelectSalutation] = useState(optionSalutation[0]);
  //const [selectGroup, setSelectGroup] = useState("");
  //const [selectRelationship, setSelectRelationship] = useState("");
  const [selectLeadChannel, setSelectLeadChannel] = useState(optionLeadChannel[0]);
  const [selectLeadSource, setSelectLeadSource] = useState("");
  const [leadSourceOptions, setLeadSourceOptions] = useState([]);
  const [selectChannelPartner, setSelectChannelPartner] = useState("");
  const [selectCountry, setSelectCountry] = useState(optionCountry[0]);
  const [selectCountryOne, setSelectCountryOne] = useState(optionCountry[0]);

  const [selectFirmType, setSelectFirmType] = useState(firmType[0]);

  const [industryTypes, setIndustryTypes] = useState([]);
  const [selectIndustryType, setSelectIndustryType] = useState("");

  const [selectMedia, setSelectMedia] = useState(media[0]);
  const [selectProduct, setSelectProduct] = useState();
  const [filterProductName, setFilterProductName] = useState("")
  const [selectProductOption, setSelectProductOption] = useState([]);
  const [selectExServiceProviderOne, setSelectExServiceProviderOne] =
    useState(ExServiceProviderOne[0]);
  const [selectExServiceProviderTwo, setSelectExServiceProviderTwo] =
    useState(ExServiceProviderTwo[0]);
  const [selectDataCenter, setSelectDataCenter] = useState(optionDataCenter[0]);
  const [selectInterestedFirewall, setSelectInterestedFirewall] = useState(optionFirewall[0]);
  const [selectInterestedVPN, setSelectInteretedVPN] = useState(optionInterestedVPN[0]);
  const [selectServiceProviderOne, setSelectServiceProviderOne] = useState(optionServiceFromServiceProvider1[0]);
  const [selectServiceProviderTwo, setSelectServiceProviderTwo] = useState(optionServiceFromServiceProvider2[0]);
  const [selectInterestedVOIP, setSelectInterestedVOIP] = useState(optionInterestedVOIP[0]);
  const [selectInterestedManageWiFi, setSelectInterestedManageWiFi] =
    useState(optionInterestedManageWiFi[0]);
  const [selectFirewall, setSelectFirewall] = useState(optionFirewall[0]);
  const [selectIsMultilocationCust, setSelectIsMultilocationCust] =
    useState(optionIsMultilocationCust[0]);
  const [selectPaymentMode, setSelectPaymentMode] = useState(optionPaymentMode[0]);
  const [selectExistingServProvInfra, setSelectExistingServProvInfra] =
    useState(optionExistingServProvInfra[0]);
  const [useSameData, setUseSameData] = useState(false);
  const [status, setStatus] = useState(null);
  const [flrStatus, setFlrStatus] = useState(null);

  const [comName, setComName] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [getDigiCompanyId, setGetDigiCompanyId] = useState("");
  const [relationShipId, setRelationShipId] = useState("");
  const [getGroup, setGetGroup] = useState("");
  const [getCity, setGetCity] = useState("");

  const [verticalOptions, setVerticalOptions] = useState([]); 
const [selectedVertical, setSelectedVertical] = useState("");

  // const handleSelectBusiness = (e) => {
  //   setSelectBusiness(e.target.value);
  // };
  const handleSelectSubBusiness = (selectSubBusiness) => {
    setSelectSubBusiness(selectSubBusiness);
  };
  const handleSelectCustomerSeg = (selectCustomerSeg) => {
    setSelectCustomerSeg(selectCustomerSeg);
  };
  const handleSelectSalutation = (selectSalutation) => {
    setSelectSalutation(selectSalutation);
  };
  const handleSelectRelationship = (selectRelationship) => {
    setSelectRelationship(selectRelationship);
  };
  const handleSelectGroup = (selectGroup) => {
    // setGroupOptions(selectGroup);
    setSelectedGroup(selectGroup);
  };
  const handleSelectLeadChannel = (selectLeadChannel) => {
    setSelectLeadChannel(selectLeadChannel);
  };
  const handleSelectLeadSource = (selectLeadSource) => {
    setSelectLeadSource(selectLeadSource);
  };
  const handleSelectChannelPartner = (selectChannelPartner) => {
    setSelectChannelPartner(selectChannelPartner);
  };
  const handleSelectCountry = (selectCountry) => {
    setSelectCountry(selectCountry);
  };
  const handleSelectCountryOne = (selectCountryOne) => {
    // console.log(selectCountryOne);

    setSelectCountryOne(selectCountryOne);
  };
  const handleSelectFirmType = (selectFirmType) => {
    setSelectFirmType(selectFirmType);
  };
  const handleSelectIndustryType = (selectIndustryType) => {
    setSelectIndustryType(selectIndustryType);
  };
  const handleSelectMedia = (selectMedia) => {
    setSelectMedia(selectMedia);
  };

  const handleSelectproduct = (productName) => {
    setSelectProduct(productName);
  }
  const handleSelectServiceProviderOne = (selectServiceProviderOne) => {
    setSelectExServiceProviderOne(selectServiceProviderOne);
    //const selectedIndex = serviceProviderOne.findIndex(provider => provider.value === e.target.value);
    //console.log('Selected Index:', selectedIndex);
  };
  const handleSelectServiceProviderTwo = (serviceProviderTwo) => {
    setSelectExServiceProviderTwo(serviceProviderTwo);
  };
  const handleCurrentWorkLocation = (currentWorkLocation) => {
    // console.log(currentWorkLocation);

    setSelectCurrentWorkLocation(currentWorkLocation);
  };
  const handleDataCenter = (selectDataCenter) => {
    setSelectDataCenter(selectDataCenter);
  };
  const handleInterestedFirewall = (selectFirewall) => {
    setSelectInterestedFirewall(selectFirewall);
  };
  const handleInterestedVPN = (selectVPN) => {
    setSelectInteretedVPN(selectVPN);
  };
  const handleServiceProviderOne = (selectServiceProviderOne) => {
    setSelectServiceProviderOne(selectServiceProviderOne);
  };
  const handleServiceProviderTwo = (selectServiceProviderTwo) => {
    setSelectServiceProviderTwo(selectServiceProviderTwo);
  };
  const handleInterestedVOIP = (selectInterestedVOIP) => {
    setSelectInterestedVOIP(selectInterestedVOIP);
  };
  const handleInterestedManageWiFi = (selectInterestedManageWiFi) => {
    setSelectInterestedManageWiFi(selectInterestedManageWiFi);
  };
  const handleFirewall = (selectFirewall) => {
    setSelectFirewall(selectFirewall);
  };
  const handleIsMultilocationCust = (selectIsMultilocationCust) => {
    setSelectIsMultilocationCust(selectIsMultilocationCust);
  };
  const handleSelectPaymentMode = (selectPaymentMode) => {
    setSelectPaymentMode(selectPaymentMode);
  };
  const handleExistingServProvInfra = (selectExistingServProvInfra) => {
    setSelectExistingServProvInfra(selectExistingServProvInfra);
  };
  const handleChange = (e) => {
    // console.log(e.target.name, e.target.value);
    setUserLeadData({ ...userLeadData, [e.target.name]: e.target.value });
  };

  const handleCheckboxChange = () => {
    // console.log("checked")
    const newValue = !useSameData;
    setUseSameData(newValue);

    if (newValue) {
      setSelectCountryOne(selectCountry);
      setSelectStateOne(selectState);
      setSelectCityOne(selectCity);
      setSelectAreaOne(selectArea);
      setSelectBuildingOne(selectBuilding);
      setUserLeadData((prevData) => ({
        ...prevData,
        blockOne: prevData.block,
        floorOne: prevData.floor,
        pinOne: prevData.pin,
        buildingNumOne: prevData.buildingNum,
        specifyBuildingOne: prevData.specifyBuilding,
        specifyAreaOne: prevData.specifyArea,
      }));
    } else {

      // Optionally reset the "One" states if needed when unchecked
      setSelectCountryOne('');
      setSelectStateOne('');
      setSelectCityOne('');
      setSelectAreaOne('');
      setSelectBuildingOne('');
      setUserLeadData((prevData) => ({
        ...prevData,
        blockOne: '',
        floorOne: '',
        pinOne: '',
        buildingNumOne: '',
        specifyBuildingOne: '',
        specifyAreaOne: '',
      }));
    }
  };

  const fetchCompanyData = async () => {
    try {
      setLoaders(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestBody = {
        Action: "getCompany",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        companyId: "New Company",
        password: sessionStorage.getItem('password'),
        userName: sessionStorage.getItem('userName'),
      };

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      //console.log("conpany name :", data.Response.Data);
      if (data.Status === "Success" && data.StatusCode === "200") {
        // return data.Response.Data.map((company) => ({
        //   label: `${company.Company_Name} (${company.Company_ID})`,
        //   value: company.Company_ID,
        //   group: `${company.Group_Name} (${company.Group_ID})`,
        //   groupId: company.Group_ID,
        // }));
        return data.Response.Data.map((company) => ({
          label: company.Company_Name,
          value: company.Company_ID,
          group: company.Group_Name,
          groupId: company.Group_ID,
        }));
      } else {
        console.error("Error in API response:", data);
        return [];
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    } finally {
      setLoaders(false);
    }
    return [];
  };

  const fetchRelationshipData = async (companyId) => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestBody = {
        Action: "getRelationship",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        companyId: companyId,
        password: sessionStorage.getItem('password'),
        userName: sessionStorage.getItem('userName'),
      };
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const data = await response.json();
      if (data.Status === "Success" && data.StatusCode === "200") {
        return data.Response.Data.map((relationship) => ({
          label: relationship.Relationship_Name,
          value: relationship.Relationship_ID,
        }));
      } else {
        console.error("Error in API response:", data);
        return [];
      }
    } catch (error) {
      console.error("Error fetching relationship data:", error);
    }
    return [];
  };

  useEffect(() => {
    const loadOptions = async () => {
      const options = await fetchCompanyData("");
      let defaultCompanyGroupObj = options?.find((company) => (company.label).includes(userLeadData.companyName || "New Company"));
      // console.log(options, defaultCompanyGroupObj);
      // console.log(userLeadData.companyName);



      // setSelectedCompany({
      //   value: defaultCompanyGroupObj?.value,
      //   label:defaultCompanyGroupObj?.label,
      // });

      // setSelectedGroup({
      //   value: defaultCompanyGroupObj?.groupId,
      //   label:defaultCompanyGroupObj?.group,
      // });

      //   if(relationshipOptions?.length > 0){
      //   let defaultRelationshipObj = relationshipOptions?.find((relationship) => relationship.value == userLeadDataRaw?.RelationshipId);
      //   setSelectRelationship(defaultRelationshipObj);
      // }

      setCompanyOptions(options);

    };
    loadOptions();
  }, [userLeadData]);



  useEffect(() => {
    // Update group options when selectedCompany changes
    if (selectedCompany) {
      setGroupOptions([
        { label: selectedCompany.group, value: selectedCompany.groupId },
      ]);
      // setLeadName(selectedCompany.label); // Automatically set leadName to the selected company name
      //setCompanyId(selectedCompany.companyId); // Set the selected company ID
    } else {
      setGroupOptions([]);
      // setLeadName(""); // Reset leadName when no company is selected
      //setCompanyId(""); // Reset companyId when no company is selected
    }
  }, [selectedCompany]); // Only trigger the effect when selectedCompany changes

  useEffect(() => {
    const loadRelationships = async () => {
      if (selectedCompany) {
        const relationshipOptions = await fetchRelationshipData(
          selectedCompany.value
        );
        setRelationshipOptions(relationshipOptions);
        // console.log(relationshipOptions);

        setSelectRelationship(relationshipOptions.find((relation) => relation.value == relationShipId))
      }
    };
    loadRelationships();
  }, [selectedCompany]);

  const handleCompanyChange = (selectedOption) => {
    // console.log("selectedOption", selectedOption);
    setSelectedCompany(selectedOption);
    setSelectedGroup(null);
    setSelectRelationship(null)
    //setCompanyId(selectedOption ? selectedOption.value : "");
  };

  // const { LeadId } = useParams();
  // console.log(LeadId);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const leadId = searchParams.get("LeadId");
  // console.log(leadId);
  const ContactId = searchParams.get("ContactId");

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL;
        const requestBody = {
          Action: "getLeads",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          ContactId: ContactId ? ContactId : "",
          LeadId: leadId ? leadId : "",
          password: sessionStorage.getItem('password'),
          userName: sessionStorage.getItem('userName')
        }
        const response = await fetch(apiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        });
        const data = await response.json();
        // console.log("getLeads", data);

        setGetCity(data.Response[0].installationAddress.InstallCityName);
        setComName(data.Response[0].companyDetail.CompanyName)
        setCompanyId(data.Response[0].CompanyId);
        setRelationShipId(data.Response[0].RelationshipId)
        setGetGroup(data.Response[0].GroupId);
        setUseSameDataRaw(data.Response[0])
        let relationshipOptions1

        if (data.Response[0].CompanyId) {
          relationshipOptions1 = await fetchRelationshipData(
            data.Response[0].CompanyId
          );
          // console.log("relationshipOptions1",relationshipOptions1);
          setRelationshipOptions(relationshipOptions1);
        }

        const verticalId = data.Response[0]?.VerticalID || "";     
        // Find matching option from verticalOptions
        const selectedVerticalOption = verticalOptions.find(option => option.value === verticalId) || null; 
        // Update state
        setSelectedVertical(selectedVerticalOption);
        
        setUserLeadData({
          topic: data.Response[0].LeadTopic,
          leadId: data.Response[0].LeadId,
          PersonName: data.Response[0].ContactPersonName,
          mobileNo: data.Response[0].MobileNo,
          email: data.Response[0].EmailId,
          leadName: data.Response[0].FirstName,
          companyName: data.Response[0].CompanyNameCompany,
          buildingNum: data.Response[0].installationAddress.InstallPlotNo,
          buildingNumOne: data.Response[0].contactAddress.ContactPlotNo,
          specifyBuilding:
            data.Response[0].installationAddress.InstallSpecifyBuilding,
          specifyBuildingOne:
            data.Response[0].contactAddress.ContactSpecifyBuilding,
          specifyArea: data.Response[0].installationAddress.InstallSpecifyArea,
          specifyAreaOne: data.Response[0].contactAddress.ContactSpecifyArea,
          block: data.Response[0].installationAddress.Block,
          floor: data.Response[0].installationAddress.InstallFloor,
          pin: data.Response[0].installationAddress.InstallPincode,
          blockOne: data.Response[0].contactAddress.ContactBlock,
          floorOne: data.Response[0].contactAddress.ContactFloor,
          pinOne: data.Response[0].contactAddress.ContactPincode,
          jobTitle: data.Response[0].companyDetail.JobTitle,
          onFirewall: data.Response[0].otherDetail.SpendOnFirewall,
          howManyLocations: data.Response[0].otherDetail.HowManyLocations,
          setSelectPaymentMode: data.Response[0].otherDetail.PaymentMode,
          actualContract: data.Response[0].otherDetail.ActualContract,
          detailServProvInfra: data.Response[0].otherDetail.DetailServProvInfra,
          targetInstallationPeriod:
            data.Response[0].otherDetail.TargetInstallationPeriod,
          contractExpDate: data.Response[0].otherDetail.ContractExpDate,
          remark: data.Response[0].Remark,
        });
        // setSelectBusiness(data.Response[0].BusinessSegment);
        if (data.Response[0].IsSameAddress == 1) {
          setUseSameData(true);
        } else {
          setUseSameData(false);
        }
        // setUseSameData(data.Response[0].IsSameAddress)
        setStatus(data.Response[0].Status);
        setFlrStatus(data.Response[0].FLRstatus);
        // setSelectSubBusiness(data.Response[0].installationAddress.InstallStateName);
        // const filterSubBusinessSegment = optionSubBusiness.find(item => item.value === String(data.Response[0].SubBusinessSegment)).label;
        setSelectSubBusiness(
          {
            value: data.Response[0].SubBusinessSegment,
            label: data.Response[0].SubBusinessSegment,
          })
        setSelectLeadChannel(
          {
            value: data.Response[0] ? data.Response[0].LeadChannel : "",
            label: data.Response[0] ? data.Response[0].LeadChannel : "",
          });
        setSelectLeadSource(
          {
            value: data.Response[0].LeadSource,
            label: data.Response[0].LeadSource,
          });
        setLeadName(data.Response[0].FirstName);
        setCompanyName(data.Response[0].companyDetail.CompanyName);
        setSelectedCompany({
          label: `${data.Response[0].CompanyNameCompany}`,
          value: data.Response[0].CompanyId,
          group: data.Response[0].GroupName,
          groupId: data.Response[0].GroupId,
        });

        setSelectedGroup({
          label: data.Response[0].GroupName,
          value: data.Response[0].GroupId,
        });
        // setGroupOptions(data.Response[0].GroupName);
        // const filterRelationshipId = relationshipOptions.find(item => item.value === String(data.Response[0].RelationshipId)).label;
        // setSelectRelationship(
        //   {
        //     value: data.Response[0].RelationshipId,
        //     label: data.Response[0].RelationshipId,
        //   });
        setSelectChannelPartner(data.Response[0].ChannelPartner);
        setSelectCountry(
          {
            value: data.Response[0].installationAddress.InstallCountry,
            label: data.Response[0].installationAddress.InstallCountryName,
          });
        setSelectState(
          {
            value: data.Response[0].installationAddress.InstallState,
            label: data.Response[0].installationAddress.InstallStateName,
          });
        setSelectCity(
          {
            value: data.Response[0].installationAddress ? data.Response[0].installationAddress.InstallCity : "",
            label: data.Response[0].installationAddress ? data.Response[0].installationAddress.InstallCityName : "",
          });
        setSelectCountryOne(
          {
            value: data.Response[0].contactAddress.ContactCountry,
            label: data.Response[0].contactAddress.ContactCountryName,
          });
        setSelectStateOne(
          {
            value: data.Response[0].contactAddress.ContactState,
            label: data.Response[0].contactAddress.ContactStateName,
          });
        setSelectCityOne(
          {
            value: data.Response[0].contactAddress.ContactCity,
            label: data.Response[0].contactAddress.ContactCityName,
          });
        setSelectArea({
          value: data.Response[0].installationAddress.InstallArea,
          label: data.Response[0].installationAddress.InstallArea && data.Response[0].installationAddress.InstallArea ?
            `${data.Response[0].installationAddress.InstallAreaName} (${data.Response[0].installationAddress.InstallArea})` : "",
        });
        setSelectAreaOne({
          value: data.Response[0].contactAddress.ContactArea,
          label: data.Response[0].contactAddress.ContactArea && data.Response[0].contactAddress.ContactAreaName ?
            `${data.Response[0].contactAddress.ContactAreaName} (${data.Response[0].contactAddress.ContactArea})` : "",
        });
        setSelectBuilding({
          value: data.Response[0].installationAddress.InstallBuilding,
          label: data.Response[0].installationAddress.InstallBuilding && data.Response[0].installationAddress.InstallBuildingName ? `${data.Response[0].installationAddress.InstallBuildingName} (${data.Response[0].installationAddress.InstallBuilding})` : "",
        });
        setSelectBuildingOne({
          value: data.Response[0].contactAddress.ContactBuilding,
          label: data.Response[0].contactAddress.ContactBuilding && data.Response[0].contactAddress.ContactBuildingName ? `${data.Response[0].contactAddress.ContactBuildingName} (${data.Response[0].contactAddress.ContactBuilding})` : "",
        });
        const filterfirmType = firmType.find(item => item.value === String(data.Response[0].companyDetail.FirmType)).label;
        setSelectFirmType(
          {
            value: data.Response[0].companyDetail.FirmType,
            label: filterfirmType,
          });
        const filterIndustryType = industryTypes.find(item => item.value === String(data.Response[0].companyDetail.IndustryType)).label;
        setSelectIndustryType(
          {
            value: data.Response[0].companyDetail.IndustryType,
            label: filterIndustryType,
            // label: data.Response[0].companyDetail.IndustryType,
          });

        // console.log("selectProductOption", selectProductOption)
        const productName = data.Response[0].ProductName;
        // console.log("data.Response[0].ProductName", data.Response[0].ProductName);
        // Find the product in selectProductOption
        const matchedProduct = selectProductOption.find(
          (product) => product.ProductID === productName
        );
        // console.log("matchedProduct", matchedProduct);
        if (matchedProduct) {
          // console.log("Found ProductName:", matchedProduct.ProductName);
          setSelectProduct({
            value: data.Response[0].ProductName,
            label: matchedProduct.ProductName,
          });
        }
        const filtermedia = media.find(item => item.value === String(data.Response[0].otherDetail.Media)).label;
        setSelectMedia({
          value: data.Response[0].otherDetail.Media,
          label: filtermedia
        });

        const filterExServiceProviderOne = ExServiceProviderOne.find(item => item.value === String(data.Response[0].otherDetail.ExistingServiceProvider1)).label;
        setSelectExServiceProviderOne(
          {
            value: data.Response[0].otherDetail.ExistingServiceProvider1,
            label: filterExServiceProviderOne,
          });
        const filterExServiceProviderTwo = ExServiceProviderTwo.find(item => item.value === String(data.Response[0].otherDetail.ExistingServiceProvider2)).label;
        setSelectExServiceProviderTwo(
          {
            value: data.Response[0].otherDetail.ExistingServiceProvider2,
            label: filterExServiceProviderTwo,
          }
        );
        setSelectCurrentWorkLocation(
          {
            value: data.Response[0].otherDetail.CurrentWorkingLocationId,
            label: data.Response[0].otherDetail.CurrentWorkingLocation,
          });
        const filterDatacenter = optionDataCenter.find(item => item.value === String(data.Response[0].otherDetail.IsDatacenter)).label;
        setSelectDataCenter(
          {
            value: data.Response[0].otherDetail.IsDatacenter,
            label: filterDatacenter
          });
        const filterFirewall = optionInterestedFirewall.find(item => item.value === String(data.Response[0].otherDetail.IsFirewall)).label;
        setSelectInterestedFirewall(
          {
            value: data.Response[0].otherDetail.IsFirewall,
            label: filterFirewall,
          });
        const filterIsVPN = optionInterestedVPN.find(item => item.value === String(data.Response[0].otherDetail.IsVPN)).label;
        setSelectInteretedVPN(
          {
            value: data.Response[0].otherDetail.IsVPN,
            label: filterIsVPN,
          });
        const filterServiceProviderOne = optionServiceFromServiceProvider1.find(item => item.value === String(data.Response[0].otherDetail.ServiceFromServiceProvider1)).label;
        setSelectServiceProviderOne(
          {
            value: data.Response[0].otherDetail.ServiceFromServiceProvider1,
            label: filterServiceProviderOne,
          });
        const filterServiceProviderTwo = optionServiceFromServiceProvider2.find(item => item.value === String(data.Response[0].otherDetail.ServiceFromServiceProvider2)).label;
        setSelectServiceProviderTwo(
          {
            value: data.Response[0].otherDetail.ServiceFromServiceProvider2,
            label: filterServiceProviderTwo,
          }
        );
        const filterIsVOIP = optionInterestedVOIP.find(item => item.value === String(data.Response[0].otherDetail.IsVOIP)).label;
        setSelectInterestedVOIP(
          {
            value: data.Response[0].otherDetail.IsVOIP,
            label: filterIsVOIP,
          });
        const filterIsManagesWiFi = optionInterestedManageWiFi.find(item => item.value === String(data.Response[0].otherDetail.IsManagesWiFi)).label;
        setSelectInterestedManageWiFi(
          {
            value: data.Response[0].otherDetail.IsManagesWiFi,
            label: filterIsManagesWiFi,
          }
        );
        const filterIsCustUsingFirewall = optionFirewall.find(item => item.value === String(data.Response[0].otherDetail.IsCustUsingFirewall)).label;
        setSelectFirewall(
          {
            value: data.Response[0].otherDetail.IsCustUsingFirewall,
            label: filterIsCustUsingFirewall,
          });
        const filterPaymentMode = optionPaymentMode.find(item => item.value === String(data.Response[0].otherDetail.PaymentMode)).label;
        setSelectPaymentMode(
          {
            value: data.Response[0].otherDetail.PaymentMode,
            label: filterPaymentMode,
          })
        const filterIsMultilocationCust = optionIsMultilocationCust.find(item => item.value === String(data.Response[0].otherDetail.IsMultilocationCust)).label;
        setSelectIsMultilocationCust(
          {
            value: data.Response[0].otherDetail.IsMultilocationCust,
            label: filterIsMultilocationCust,
          }
        );
        const filterExistingServProvInfra = optionExistingServProvInfra.find(item => item.value === String(data.Response[0].otherDetail.ExistingServProvInfra)).label;
        setSelectExistingServProvInfra(
          {
            value: data.Response[0].otherDetail.ExistingServProvInfra,
            label: filterExistingServProvInfra,
          }
        );
        const filterCustomerSegment = optionCustomerSeg.find(item => item.value === String(data.Response[0].CustomerSegment)).label;
        setSelectCustomerSeg(
          {
            value: data.Response[0].CustomerSegment,
            label: filterCustomerSegment,
          });
        const filterSalutationId = optionSalutation.find(item => item.value === String(data.Response[0].SalutationId)).label;
        setSelectSalutation(
          {
            value: data.Response[0].SalutationId,
            label: filterSalutationId,
          });
        const relationshipId = data.Response[0].RelationshipId;
        const filterRelationshipId = relationshipOptions1 ? relationshipOptions1.find(item => String(item.value) === String(relationshipId)) : null;
        // console.log("filterRelationshipId",filterRelationshipId);
        // if (filterRelationshipId) {
        //   setSelectRelationship({
        //     value: filterRelationshipId ? filterRelationshipId.value : "",
        //     label: filterRelationshipId ? filterRelationshipId.label : "",
        //   });
        // } else {
        //   console.error("RelationshipId not found in relationshipOptions");
        // }

      } catch (error) {
        //console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();

  }, [leadId, industryTypes, ContactId, selectProductOption]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Industry API call
        const industryTypeApiUrl = process.env.REACT_APP_API_URL;
        const industryTypeRequestBody = {
          Action: "getindustrytype",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          areaCode: "",
          areaName: "",
          password: sessionStorage.getItem('password'),
          userName: sessionStorage.getItem('userName'),
        };
        const industryTypeResponse = await fetch(industryTypeApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(industryTypeRequestBody),
        });
        const industryTypeData = await industryTypeResponse.json();
        // setIndustryTypes(industryTypeData.Response);
        // console.log("industryTypeData :",industryTypeData.Response)
        if (industryTypeData.Response) {
          const transformedOptions = industryTypeData.Response.map(
            (option) => ({
              label: option.IndTypeName,
              value: option.IndTypeId,
            })
          );
          setIndustryTypes(transformedOptions);
          // console.log("transformedOptions",transformedOptions)
        } else {
          setIndustryTypes([]);
        }

        const CityApiUrl = process.env.REACT_APP_API_URL;
        const CityRequestBody = {
          Action: "getCity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          password: sessionStorage.getItem('password'),
          stateCode: "0",
          userName: sessionStorage.getItem('userName'),
        };
        const CityResponse = await fetch(CityApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(CityRequestBody),
        });
        const CityData = await CityResponse.json();
        //console.log(CityData.Response.Data)
        // setCurrentWorkLocations(CityData.Response.Data);
        // if (CityData.Response && Array.isArray(CityData.Response.Data)) {
        //   setCurrentWorkLocations(CityData.Response.Data);
        // }
        if (CityData.Response.Data) {
          const transformedOptions = CityData.Response.Data.map(
            (option) => ({
              label: option.CityName,
              value: option.CityCode,
            })
          );
          setCurrentWorkLocations(transformedOptions);
        } else {
          setCurrentWorkLocations([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // lead source API call
        const leadSourceApiUrl = process.env.REACT_APP_API_URL;
        const leadSourceRequestBody = {
          Action: "getSource",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          channelName: selectLeadChannel.value,
          password: sessionStorage.getItem('password'),
          userName: sessionStorage.getItem('userName'),
        };
        const leadSourceResponse = await fetch(leadSourceApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(leadSourceRequestBody),
        });
        const leadSourceData = await leadSourceResponse.json();
        // console.log("lead Source :", leadSourceData.Response.Data);
        // Check if data is not undefined or null before mapping
        if (leadSourceData.Response.Data) {
          // Transforming data into the required format
          const transformedOptions = leadSourceData.Response.Data.map(
            (option) => ({
              label: option.SourceName,
              value: option.SourceName,
            })
          );
          // console.log("setLeadSourceOptions",transformedOptions)
          setLeadSourceOptions(transformedOptions);
        } else {
          // If data is undefined or null, set leadSourceOptions to an empty array
          setLeadSourceOptions([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [selectLeadChannel]);

  useEffect(() => {
    const fetchProductData = async () => {
      try {
        const productNameUrl = process.env.REACT_APP_API_URL;
        const productNameRequestBody = {
          "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          "Action": "getProductLead",
          "bussSegment": "Business",
          "password": sessionStorage.getItem('password'),
          "userName": sessionStorage.getItem('userName'),
        }
        const productNameResponse = await fetch(productNameUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(productNameRequestBody),
        });
        const productNameData = await productNameResponse.json();
        // console.log("productNameData", productNameData);
        setSelectProductOption(productNameData.Response.Data);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchProductData();
  }, []);

  const handleSelectCity = async (selectedOption) => {
    const selectedCityCode = selectedOption ? selectedOption.value : "";
    const selectedCityName = selectedOption ? selectedOption.label : "";
    // console.log("selectedCityCode", selectedOption.value);
    // console.log("selectedCityName", selectedOption.label);
    setSelectCity(selectedOption);
    setSelectArea("");
    setSelectBuilding("");
    try {
      const areaApiUrl = process.env.REACT_APP_API_URL;
      const areaRequestBody = {
        Action: "getArea",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        cityCode: selectedCityCode,
        cityName: selectedCityName,
        password: sessionStorage.getItem('password'),
        restrictedarea: false,
        stateCode: "",
        userName: sessionStorage.getItem('userName'),
      };
      const areaResponse = await fetch(areaApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(areaRequestBody),
      });
      const areaData = await areaResponse.json();
      if (areaData.Response && Array.isArray(areaData.Response.Data)) {
        // console.log("area :", areaData.Response.Data);
        setAreaList(areaData.Response.Data);
      }
    } catch (error) {
      console.error("Error fetching area data:", error);
    }
  };

  const handleSelectCityOne = async (selectedOption) => {
    const selectedCityCode = selectedOption ? selectedOption.value : "";
    const selectedCityName = selectedOption ? selectedOption.label : "";
    // console.log("selectedCityCode", selectedOption.value);
    // console.log("selectedCityName", selectedOption.label);
    setSelectCityOne(selectedOption);
    setSelectAreaOne("");
    setSelectBuildingOne("");
    try {
      const areaApiUrl = process.env.REACT_APP_API_URL;
      const areaRequestBody = {
        Action: "getArea",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        cityCode: selectedCityCode,
        cityName: selectedCityName,
        password: sessionStorage.getItem('password'),
        restrictedarea: false,
        stateCode: "",
        userName: sessionStorage.getItem('userName'),
      };
      const areaResponse = await fetch(areaApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(areaRequestBody),
      });
      const areaData = await areaResponse.json();
      if (areaData.Response && Array.isArray(areaData.Response.Data)) {
        // console.log("area :", areaData.Response.Data);
        setAreaList(areaData.Response.Data);
      }
    } catch (error) {
      console.error("Error fetching area data:", error);
    }
  };

  const handleSelectState = (selectedState) => {
    setSelectState(selectedState);
    setSelectCity("");
    setSelectArea("");
    setSelectBuilding("");
  };

  const handleSelectStateOne = (selectedStateOne) => {
    setSelectStateOne(selectedStateOne);
    setSelectCityOne("");
    setSelectAreaOne("");
    setSelectBuildingOne("");
  };

  useEffect(() => {
    const fetchCities = async () => {
      try {
        // City API call
        const cityApiUrl = process.env.REACT_APP_API_URL;
        const cityRequestBody = {
          Action: "getCity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          password: sessionStorage.getItem('password'),
          stateCode: selectState.value,
          userName: sessionStorage.getItem('userName'),
        };
        const cityResponse = await fetch(cityApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cityRequestBody),
        });
        const cityData = await cityResponse.json();

        if (cityData.Response && Array.isArray(cityData.Response.Data)) {
          setCityType(cityData.Response.Data);
          setCityTypeOne(cityData.Response.Data);
        } else {
          // console.error(
          //   "City data structure not recognized:",
          //   cityData.Response
          // );
          setCityType([]);
          setCityTypeOne([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Fetch cities only if a state is selected
    if (selectState) {
      fetchCities();
    }
  }, [selectState]);

  useEffect(() => {
    const fetchCities = async () => {
      try {
        // City API call
        const cityApiUrl = process.env.REACT_APP_API_URL;
        const cityRequestBody = {
          Action: "getCity",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          password: sessionStorage.getItem('password'),
          stateCode: selectStateOne.value,
          userName: sessionStorage.getItem('userName'),
        };
        const cityResponse = await fetch(cityApiUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(cityRequestBody),
        });
        const cityData = await cityResponse.json();

        if (cityData.Response && Array.isArray(cityData.Response.Data)) {
          setCityTypeOne(cityData.Response.Data);
        } else {
          // console.error(
          //   "City data structure not recognized:",
          //   cityData.Response
          // );

          setCityTypeOne([]);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // Fetch cities only if a state is selected
    if (selectStateOne) {
      fetchCities();
    }
  }, [selectStateOne]);

  const handleSelectArea = async (selectedOption) => {
    setSelectArea(selectedOption);
    setSelectBuilding("");
    const areaCode = selectedOption.value;
    const areaName = selectedOption.label.split(" ")[0];
    try {
      const buildingApiUrl = process.env.REACT_APP_API_URL;
      const buildingRequestBody = {
        Action: "getBuilding",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        areaCode: areaCode,
        areaName: areaName,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const buildingResponse = await fetch(buildingApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(buildingRequestBody),
      });
      const buildingData = await buildingResponse.json();
      if (buildingData.Response && Array.isArray(buildingData.Response.Data)) {
        setBuildingList(buildingData.Response.Data);
      }
    } catch (error) {
      console.error("Error fetching building data:", error);
    }
  };



  // const emailValidation = async (email) => {
  //   !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i.test(email)
  // }

  const handleSelectAreaOne = async (selectedOption) => {
    setSelectAreaOne(selectedOption);
    setSelectBuildingOne("");
    const areaCode = selectedOption.value;
    const areaName = selectedOption.label.split(" ")[0];
    try {
      const buildingApiUrl = process.env.REACT_APP_API_URL;
      const buildingRequestBody = {
        Action: "getBuilding",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        areaCode: areaCode,
        areaName: areaName,
        password: sessionStorage.getItem("password"),
        userName: sessionStorage.getItem("userName"),
      };

      const buildingResponse = await fetch(buildingApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(buildingRequestBody),
      });
      const buildingData = await buildingResponse.json();
      if (buildingData.Response && Array.isArray(buildingData.Response.Data)) {
        setBuildingList(buildingData.Response.Data);
      }
    } catch (error) {
      console.error("Error fetching building data:", error);
    }
  };

  const formatDateString = (dateString) => {
    if (leadId === null) {
      return dateString;
    } else if (dateString.indexOf("-") === 4) {
      return dateString;
    } else if (dateString.indexOf("-") === 2) {
      const [day, month, year] = dateString.split("-");
      return `${year}-${month}-${day}`;
    } else {
      // Assuming dateString is in the format DD-MM-YYYY
      const [day, month, year] = dateString.split("-");
      return `${year}-${month}-${day}`;
    }
  };

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = `${today.getMonth() + 1}`.padStart(2, "0");
    const day = `${today.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleSubmit = async () => {
    // console.log(selectCity, companyName);

    if (!userLeadData.topic) {
      toast.warning("Please Enter Topic", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
      // topicInputRef.current.focus();
    } else if (selectSubBusiness.value === "0") {
      toast.warning("Please Select Sub Business Segment", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (selectCustomerSeg.value === "0") {
      toast.warning("Please Select Customer Segment", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (selectSalutation.value === "0") {
      toast.warning("Please Select Salutation", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userLeadData.PersonName) {
      toast.warning("Please Enter Contact Person Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userLeadData.email) {
      toast.warning("Please Enter Email Id", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(userLeadData.email)
      // !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,63}$/i.test(userLeadData.email)
    ) {
      toast.warning("Invalid Email Address.Please enter a valid email.", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (userLeadData.mobileNo.length < 10) {
      toast.warning("Please Enter Mobile Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!leadName) {
      toast.warning("Please Enter Lead Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectedCompany || (!selectedCompany.label && !selectedCompany.value)) {
      toast.warning("Please Enter Company Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!groupOptions) {
      toast.warning("Please Select Group Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }

    else if (!selectRelationship) {
      toast.warning('Please Select Relationship', {
        position: toast.POSITION.BOTTOM_CENTER, autoClose: 1500
      });
    }
    else if (selectLeadChannel.value === "") {
      toast.warning("Please Select Lead Channel", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (!selectLeadSource) {
      toast.warning("Please Select Lead Source", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    // else if (!selectCountry || (!selectCountry.value && !selectCountry.label)) {
    //   toast.warning("Please Select Country", {
    //     position: toast.POSITION.BOTTOM_CENTER,
    //     autoClose: 1500,
    //   });    } 
    else if (!selectState || (!selectState.value && !selectState.label)) {
      toast.warning("Please Select State", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectCity || (!selectCity.value && !selectCity.label)) {
      toast.warning("Please Select City", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectArea || (!selectArea.value && !selectArea.label)) {
      toast.warning("Please Select Area", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectBuilding || (!selectBuilding.value && !selectBuilding.label)) {
      toast.warning("Please Enter Building Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userLeadData.buildingNum) {
      toast.warning("Please Enter Building Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userLeadData.block) {
      toast.warning("Please Enter Block", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userLeadData.floor) {
      toast.warning("Please Enter Floor", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userLeadData.pin) {
      toast.warning("Please Enter Pin Code", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (userLeadData.pin.length < 6) {
      toast.warning("Please Enter Pin Code", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    // else if (!selectCountryOne || (!selectCountryOne.label && !selectCountryOne.value)) {
    //   toast.warning("Please Select Country", {
    //     position: toast.POSITION.BOTTOM_CENTER,
    //     autoClose: 1500,
    //   });
    // } 
    else if (!selectStateOne || (!selectStateOne.label && !selectStateOne.value)) {
      toast.warning("Please Select State", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectCityOne || (!selectCityOne?.label && !selectCityOne?.value)) {
      toast.warning("Please Select City", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectAreaOne || (!selectAreaOne.label && !selectAreaOne.value)) {
      toast.warning("Please Select Area", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectBuildingOne || (!selectBuildingOne.label && !selectBuildingOne.value)) {
      toast.warning("Please Enter Building Name", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userLeadData.buildingNumOne) {
      toast.warning("Please Enter Building Number", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userLeadData.blockOne) {
      toast.warning("Please Enter Block", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userLeadData.floorOne) {
      toast.warning("Please Enter Floor", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userLeadData.pinOne) {
      toast.warning("Please Enter Pin Code", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (userLeadData.pinOne.length < 6) {
      toast.warning("Please Enter Pin Code", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    else if (selectFirmType.value === "0") {
      toast.warning("Please Select Firm Type", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectIndustryType) {
      toast.warning("Please Select Industry Type", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    }
    // else if (!userLeadData.jobTitle) {
    //   toast.warning("Please Enter Job Title", {
    //     position: toast.POSITION.BOTTOM_CENTER,
    //     autoClose: 1500,
    //   });
    // }
    //  else if (!selectProduct) {
    //   toast.warning("Please Select Product", {
    //     position: toast.POSITION.BOTTOM_CENTER,
    //     autoClose: 1500,
    //   });
    // } 
    else if (selectExServiceProviderOne.value === "0") {
      toast.warning("Please Select Existing Service Provider 1", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (selectExServiceProviderTwo.value === "0") {
      toast.warning("Please Select Existing Service Provider 2", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!selectCurrentWorkLocation) {
      toast.warning("Please Select Current Work Locations ", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (selectDataCenter.value === "") {
      toast.warning("Please Select Data Center / Cloud Services ", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (selectInterestedFirewall.value === "") {
      toast.warning("Please Select Customer Interested In Firewall ", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (selectInterestedVPN.value === "") {
      toast.warning("Please Select Customer Interested In VPN Services ", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (selectServiceProviderOne.value === "") {
      toast.warning("Please Select Services From Service Provider 1", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (selectServiceProviderTwo.value === "") {
      toast.warning("Please Select Services From Service Provider 2", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (selectInterestedVOIP.value === "") {
      toast.warning("Please Select Customer Interested In VOIP", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (selectInterestedManageWiFi.value === "") {
      toast.warning("Please Select Customer Interested In Manage Wi-Fi", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (!userLeadData.targetInstallationPeriod) {
      toast.warning("Please Select Target Installation Period", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else if (selectFirewall.value === "") {
      toast.warning("Please Select Is Customer Using Firewall", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 1500,
      });
    } else {
      // update lead form data
      if (leadId) {
        setLoading(true);
        const leadUpdateUrl = process.env.REACT_APP_API_URL;
        const leadUpdationData = {
          Action: "updateLead",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          CompanyDetail: {
            companyName: (companyName || comName).split("(")[0].trim() || "",
            firmType: `${selectFirmType.value}` ? `${selectFirmType.value}` : "",
            industryType: selectIndustryType.value ? selectIndustryType.value : "",
            jobTitle: userLeadData.jobTitle ? userLeadData.jobTitle : "",
          },
          ContactAddress: {
            contactArea: selectAreaOne.label
              ? selectAreaOne.label.split("(")[1].split(")")[0].trim()
              : "",
            contactBuilding: selectBuildingOne.label
              ? selectBuildingOne.label.split("(")[1].split(")")[0].trim()
              : "",
            contactCity: selectCityOne.value ? selectCityOne.value : "",
            contactCountry: '10001', // selectCountryOne.value ? selectCountryOne.value : "",
            contactFloor: userLeadData.floorOne ? userLeadData.floorOne : "",
            contactPincode: userLeadData.pinOne ? userLeadData.pinOne : "",
            contactPlotNo: userLeadData.buildingNumOne
              ? userLeadData.buildingNumOne
              : "",
            contactSpecifyArea: userLeadData.specifyAreaOne
              ? userLeadData.specifyAreaOne
              : " ",
            contactSpecifyBuilding: userLeadData.specifyBuildingOne
              ? userLeadData.specifyBuildingOne
              : "",
            contactState: selectStateOne.value ? selectStateOne.value : "",
            contactblock: userLeadData.blockOne ? userLeadData.blockOne : "",
          },
          InstallationAddress: {
            block: userLeadData.block ? userLeadData.block : "",
            installArea: selectArea.label
              ? selectArea.label.split("(")[1].split(")")[0].trim()
              : "",
            installBuilding: selectBuilding.label
              ? selectBuilding.label.split("(")[1].split(")")[0].trim()
              : "",
            installCity: selectCity.value ? selectCity.value : "",
            installCountry: selectCountry.value ? selectCountry.value : "",
            installFloor: userLeadData.floor ? userLeadData.floor : "",
            installPincode: userLeadData.pin ? userLeadData.pin : " ",
            installPlotNo: userLeadData.buildingNum
              ? userLeadData.buildingNum
              : "",
            installSociety: "0",
            installSpecifyArea: userLeadData.specifyArea
              ? userLeadData.specifyArea
              : "",
            installSpecifyBuilding: userLeadData.specifyBuilding
              ? userLeadData.specifyBuilding
              : "",
            installState: selectState.value ? selectState.value : "",
          },
          SDWAN: {
            applicationsHosted: "",
            currentOperationalCity: "",
            customerBroadbandServices: "",
            customerILLservices: "",
            customerRoutingServices: "",
            firewallSetToExpire: "",
            indicationITSpent: "",
            itSupport: "",
            linksManagedLinks: "",
            mPLSBackbone: "",
            mPLSContract: "",
            networkSecurityServices: "",
            noOfLocation: "",
            numberOfLinksBroadbandServices: "",
            numberOfLinksIll: "",
            redundancyMPLS: "",
            sdwanRemarks: "",
          },
          businessSegment: "Business",
          companyID: selectedCompany?.value || "",
          contactPersonName: userLeadData.PersonalName
            ? userLeadData.PersonalName
            : " ",
          customersegment: `${selectCustomerSeg.value}` ? `${selectCustomerSeg.value}` : " ",
          emailId: userLeadData.email ? userLeadData.email : " ",
          ems: "3",
          firstName: leadName ? leadName.split("(")[0].trim() : "",
          groupID: groupOptions ? groupOptions[0].value : "",
          isSameAddress: useSameData ? `${1}` : `${0}`,
          lastName: "",
          leadChannel: selectLeadChannel.value ? selectLeadChannel.value : "FFA APP",
          leadId: userLeadData.leadId ? userLeadData.leadId : " ",
          leadSource: selectLeadSource?.value ? selectLeadSource?.value : "",
          leadTopic: userLeadData.topic ? userLeadData.topic : "",
          mobileNo: userLeadData.mobileNo ? userLeadData.mobileNo : " ",
          otherDetail: {
            currentWorkingLocation: selectCurrentWorkLocation.value
              ? selectCurrentWorkLocation.value
              : "",
            existingServiceProvider1: `${selectExServiceProviderOne.value}`
              ? `${selectExServiceProviderOne.value}`
              : "",
            existingServiceProvider2: `${selectExServiceProviderTwo.value}`
              ? `${selectExServiceProviderTwo.value}`
              : "",
            isDatacenter: `${selectDataCenter.value}` ? `${selectDataCenter.value}` : "",
            isFirewall: `${selectInterestedFirewall.value}`
              ? `${selectInterestedFirewall.value}`
              : "",
            isManagesWiFi: `${selectInterestedManageWiFi.value}`
              ? `${selectInterestedManageWiFi.value}`
              : "",
            isVOIP: `${selectInterestedVOIP.value}` ? `${selectInterestedVOIP.value}` : "",
            isVPN: `${selectInterestedVPN.value}` ? `${selectInterestedVPN.value}` : "",
            media: `${selectMedia.value}` ? `${selectMedia.value}` : "",
            serviceFromServiceProvider1: `${selectServiceProviderOne.value}`
              ? `${selectServiceProviderOne.value}`
              : "",
            serviceFromServiceProvider2: `${selectServiceProviderTwo.value}`
              ? `${selectServiceProviderTwo.value}`
              : "",
            targetInstallationPeriod: formatDateString(
              userLeadData.targetInstallationPeriod
            )
              ? formatDateString(userLeadData.targetInstallationPeriod)
              : "",
          },
          password: sessionStorage.getItem("password"),
          productName: selectProduct?.value ? selectProduct?.value : "",
          relationshipId: selectRelationship.value ? selectRelationship.value : "",
          remark: userLeadData.remark ? userLeadData.remark : "",
          salutationId: selectSalutation.value ? selectSalutation.value : "",
          specifyleadsource: userLeadData.specifyLeadSource ? userLeadData.specifyLeadSource : "other",
          subBusinessSegment: selectSubBusiness.label,
          userName: sessionStorage.getItem("userName"),
          verticalID: selectedVertical?.value,
        };

        // console.log("leadUpdationData: ", leadUpdationData); return

        try {
          const response = await fetch(leadUpdateUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(leadUpdationData),
          });
          //console.log('Request Payload:', JSON.stringify(leadUpdationData))
          const data = await response.json();
          // console.log('API Response lead create:', data);
          if (data.Response.Message === "Lead Updated Successfully") {
            setLoading(false);
            toast.success("Lead Updated Successfully", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
            navigate("/businessLead");
          } else {
            setLoading(false);
            toast.warning(data.Response.Message, {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }
        } catch (error) {
          console.error("Error creating lead:", error);
          toast.error("An error occurred. Please try again later.", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        }
      } else {
        // create lead data
        setLoading(true);
        const leadCreateUrl = process.env.REACT_APP_API_URL;
        const leadCreationData = {
          Action: "createLead",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          CompanyDetail: {
            companyName: companyName ? companyName.split("(")[0].trim() : "",
            firmType: selectFirmType.value ? selectFirmType.value : "",
            industryType: selectIndustryType.value ? selectIndustryType.value : "",
            jobTitle: userLeadData.jobTitle ? userLeadData.jobTitle : "",
          },
          ContactAddress: {
            contactArea: selectAreaOne.label
              ? selectAreaOne.label.split("(")[1].split(")")[0].trim()
              : "",
            contactBuilding: selectBuildingOne.label
              ? selectBuildingOne.label.split("(")[1].split(")")[0].trim()
              : "",
            contactCity: selectCityOne.value ? selectCityOne.value : "",
            contactCountry: selectCountryOne.value ? selectCountryOne.value : "",
            contactFloor: userLeadData.floorOne ? userLeadData.floorOne : "",
            contactPincode: userLeadData.pinOne ? userLeadData.pinOne : "",
            contactPlotNo: userLeadData.buildingNumOne
              ? userLeadData.buildingNumOne
              : "",
            contactSpecifyArea: userLeadData.specifyAreaOne
              ? userLeadData.specifyAreaOne
              : " ",
            contactSpecifyBuilding: userLeadData.specifyBuildingOne
              ? userLeadData.specifyBuildingOne
              : "",
            contactState: selectStateOne.value ? selectStateOne.value : "",
            contactblock: userLeadData.blockOne ? userLeadData.blockOne : "",
          },
          InstallationAddress: {
            block: userLeadData.block ? userLeadData.block : "",
            installArea: selectArea.label
              ? selectArea.label.split("(")[1].split(")")[0].trim()
              : "",
            installBuilding: selectBuilding.label
              ? selectBuilding.label.split("(")[1].split(")")[0].trim()
              : "",
            installCity: selectCity.value ? selectCity.value : "",
            installCountry: selectCountry.value ? selectCountry.value : "",
            installFloor: userLeadData.floor ? userLeadData.floor : "",
            installPincode: userLeadData.pin ? userLeadData.pin : " ",
            installPlotNo: userLeadData.buildingNum
              ? userLeadData.buildingNum
              : "",
            installSociety: "0",
            installSpecifyArea: userLeadData.specifyArea
              ? userLeadData.specifyArea
              : "",
            installSpecifyBuilding: userLeadData.specifyBuilding
              ? userLeadData.specifyBuilding
              : "",
            installState: selectState.value ? selectState.value : "",
          },
          SDWAN: {
            indicationITSpent: "",
            noOfLocation: "",
            numberOfLinksBroadbandServices: "",
            numberOfLinksIll: "",
            sdwanRemarks: "",
          },
          businessSegment: "Business",
          channelPartner: "",
          companyID: selectedCompany?.value || "",
          contactPersonName: userLeadData.PersonName
            ? userLeadData.PersonName
            : "",
          customersegment: selectCustomerSeg.value ? selectCustomerSeg.value : "",
          emailId: userLeadData.email ? userLeadData.email : "",
          ems: "3",
          firstName: leadName ? leadName.split("(")[0].trim() : "",
          groupID: groupOptions ? groupOptions[0]?.value : "",
          isSameAddress: useSameData ? 1 : 0,
          lastName: "",
          leadChannel: selectLeadChannel.value ? selectLeadChannel.value : "FFA APP",
          leadId: userLeadData.leadId ? userLeadData.leadId : " ",
          leadSource: selectLeadSource.value ? selectLeadSource.value : "",
          leadTopic: userLeadData.topic ? userLeadData.topic : "",
          mobileNo: userLeadData.mobileNo ? userLeadData.mobileNo : " ",
          otherDetail: {
            actualContract: "",
            contractExpDate: formatDateString(userLeadData.contractExpDate)
              ? formatDateString(userLeadData.contractExpDate)
              : "",
            currentWorkingLocation: selectCurrentWorkLocation.value
              ? selectCurrentWorkLocation.value
              : "",
            detailServProvInfra: userLeadData.detailServProvInfra
              ? userLeadData.detailServProvInfra
              : " ",
            existingServProvInfra: selectExistingServProvInfra.value
              ? selectExistingServProvInfra.value
              : "",
            existingServiceProvider1: selectExServiceProviderOne.value
              ? selectExServiceProviderOne.value
              : "",
            existingServiceProvider2: selectExServiceProviderTwo.value
              ? selectExServiceProviderTwo.value
              : "",
            howManyLocations: userLeadData.howManyLocations
              ? userLeadData.howManyLocations
              : " ",
            isCustUsingFirewall: selectFirewall.value ? selectFirewall.value : "",
            isDatacenter: selectDataCenter.value ? selectDataCenter.value : "",
            isFirewall: selectInterestedFirewall.value
              ? selectInterestedFirewall.value
              : "",
            isManagesWiFi: selectInterestedManageWiFi.value
              ? selectInterestedManageWiFi.value
              : "",
            isMultilocationCust: selectIsMultilocationCust.value
              ? selectIsMultilocationCust.value
              : "",
            isVOIP: selectInterestedVOIP.value ? selectInterestedVOIP.value : "",
            isVPN: selectInterestedVPN.value ? selectInterestedVPN.value : "",
            media: selectMedia.value ? selectMedia.value : "",
            paymentMode: selectPaymentMode.value ? selectPaymentMode.value : "",
            serviceFromServiceProvider1: selectServiceProviderOne.value
              ? selectServiceProviderOne.value
              : "",
            serviceFromServiceProvider2: selectServiceProviderTwo.value
              ? selectServiceProviderTwo.value
              : "",
            spendOnFirewall: userLeadData.onFirewall
              ? userLeadData.onFirewall
              : "",
            targetInstallationPeriod: formatDateString(
              userLeadData.targetInstallationPeriod
            )
              ? formatDateString(userLeadData.targetInstallationPeriod)
              : "",
          },
          password: sessionStorage.getItem("password"),
          productName: selectProduct?.value ? selectProduct?.value : "",
          relationshipId: selectRelationship.value ? selectRelationship.value : "",
          remark: userLeadData.remark ? userLeadData.remark : "",
          salutationId: selectSalutation.value ? selectSalutation.value : "",
          specifyleadsource: userLeadData.specifyLeadSource ? userLeadData.specifyLeadSource : "other",
          subBusinessSegment: selectSubBusiness.value
            ? selectSubBusiness.value
            : "",
          userName: sessionStorage.getItem("userName"),
        };
        try {
          const response = await fetch(leadCreateUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(leadCreationData),
          });
          //console.log('Request Payload:', JSON.stringify(leadCreationData))
          const data = await response.json();
          //console.log('API Response lead create:', data);
          if (data.Response.Message === "Lead Created Successfully") {
            setLoading(false);
            toast.success("Lead Created Successfully", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
            navigate("/businessLead");
          } else {
            toast.warning(data.Response.Message, {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
            setLoading(false);
          }
        } catch (error) {
          console.error("Error creating lead:", error);
          toast.error("An error occurred. Please try again later.", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        }
      }
    }
  };

  const handleSelectQualify = async (optionQualify) => {
    // console.log(optionQualify.value)
    if (optionQualify) {
      try {
        setLoading(true);
        const disqualifiedUrl = process.env.REACT_APP_API_URL;
        const disqualifiedData = {
          Action: "disqualifydLead",
          Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
          leadId: leadId,
          password: sessionStorage.getItem('password'),
          status: optionQualify.value, // Use the value of the selected option
          userName: sessionStorage.getItem('userName'),
        };

        const response = await fetch(disqualifiedUrl, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(disqualifiedData),
        });
        const data = await response.json();
        if (data.Response.StatusCode === 200) {
          // alert("done");
          setLoading(false);
          toast.success("Lead DisQualified Successfully", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
          navigate("/businessLead");
        } else {
          // alert(data.Response.Message);
          setLoading(false);
          toast.warning(data.Response.Message, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 1500,
          });
        }
      } catch (error) {
        console.error("Error during API call:", error);
      }
    }
  };

  const handleQualifyLead = async () => {
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL;
      const requestData = {
        Action: "getCompanyGroupDigi",
        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
        customerName: comName,
        password: sessionStorage.getItem('password'),
        userName: sessionStorage.getItem('userName')
      };
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });
      const data = await response.json();
      // console.log("companyId", companyId);
      setGetDigiCompanyId(data.Response.CompanyID);
      if (data.Response.StatusCode == 200 && companyId !== "CNew") {
        // alert("data.Response.StatusCode == 200 && companyId !== 'CNew'")
        try {
          const apiUrl = process.env.REACT_APP_API_URL;
          const requestData = {
            "Action": "getCompanyRelationship",
            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            "CompanyID": companyId ? companyId : "",
            "GroupID": getGroup ? getGroup : "",
            "City": getCity ? getCity : "",
            "password": sessionStorage.getItem('password'),
            "userName": sessionStorage.getItem('userName')
          };
          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
          });
          const data = await response.json();
          if (data.Response.StatusCode == 200 && relationShipId !== "10New") {
            // console.log(getCity, relationShipId, selectCity,);
            // console.log(getCity.label, selectRelationship.label);

            if (getCity == selectRelationship.label) {
              try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestData = {
                  Action: "qualifyLead",
                  Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                  leadId: leadId,
                  password: sessionStorage.getItem('password'),
                  userName: sessionStorage.getItem('userName'),
                };
                const response = await fetch(apiUrl, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(requestData),
                });
                const data = await response.json();
                // console.log("API Response:", data);
                if (data.Response.StatusCode === 200) {
                  toast.success("Lead Qualify Successfully", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                  });
                  navigate("/businessOpportunity");
                } else {
                  toast.warning(data.Response.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                  });
                }
              } catch (error) {
                console.error("Error during API call:", error);
              }
            } else {
              Swal.fire({
                // title: '<div style="font-size: 22px; margin-top:5px;">Action Required</div>',
                text: "Selected City on Installation Address and Relationship ID must be same.",
                confirmButtonText:
                  '<span style="font-size: 15px;">Ok</span>',
                confirmButtonColor: "rgb(148,101,170)",
              }).then(async (result) => {
                if (result.isConfirmed) {
                  navigate(`/businessLeadForm?LeadId=${leadId}`);
                }
                else {
                  navigate(`/businessLeadForm?LeadId=${leadId}`);
                }
              })
            }
          } else if (data.Response.StatusCode == 200 && relationShipId == "10New") {
            Swal.fire({
              // title: '<div style="font-size: 22px; margin-top:5px;">Action Required</div>',
              text: "Company & Relationship ID exist in CRM. Select and proceed with lead qualification.",
              confirmButtonText:
                '<span style="font-size: 15px;">Ok</span>',
              confirmButtonColor: "rgb(148,101,170)",
            }).then(async (result) => {
              if (result.isConfirmed) {
                navigate(`/businessLeadForm?LeadId=${leadId}`);
              }
              else {
                navigate(`/businessLeadForm?LeadId=${leadId}`);
              }
            })
          } else if (data.Response.StatusCode == 400 && data.Response.RelationShipID == "") {

            try {
              const apiUrl = process.env.REACT_APP_API_URL;
              const requestData = {
                Action: "qualifyLead",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                leadId: leadId,
                password: sessionStorage.getItem('password'),
                userName: sessionStorage.getItem('userName'),
              };
              const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
              });
              const data = await response.json();
              // console.log("API Response:", data);
              if (data.Response.StatusCode === 200) {
                toast.success("Lead Qualify Successfully", {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 1500,
                });
                navigate("/opportunity");
              } else {
                toast.warning(data.Response.Message, {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 1500,
                });
              }
            } catch (error) {
              console.error("Error during API call:", error);
            }

          }
        } catch (error) {
          console.error("Error during API call:", error);
        }

      } else if (data.Response.StatusCode == 400 && getDigiCompanyId == "" && data.Response.Message !== "Please pass valid customer name.") {

        try {
          const apiUrl = process.env.REACT_APP_API_URL;
          const requestData = {
            Action: "qualifyLead",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            leadId: leadId,
            password: sessionStorage.getItem('password'),
            userName: sessionStorage.getItem('userName'),
          };
          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
          });
          const data = await response.json();
          // console.log("API Response:", data);
          if (data.Response.StatusCode === 200) {
            toast.success("Lead Qualify Successfully", {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
            navigate("/businessOpportunity");
          } else {
            toast.warning(data.Response.Message, {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          }
        } catch (error) {
          console.error("Error during API call:", error);
        }

      } else if (data.Response.StatusCode == 200 && companyId == "CNew") {
        // alert("data.Response.StatusCode == 200 && companyId == 'CNew'")
        Swal.fire({
          // title: '<div style="font-size: 22px; margin-top:5px;">Action Required</div>',
          text: "Company and Group hierarchy already exists in CRM, Please select the same and proceed for lead qualification",
          confirmButtonText:
            '<span style="font-size: 15px;">Ok</span>',
          confirmButtonColor: "rgb(148,101,170)",
        }).then(async (result) => {
          if (result.isConfirmed) {
            navigate(`/businessLeadForm?LeadId=${leadId}`);
          }
          else {
            navigate(`/businessLeadForm?LeadId=${leadId}`);
          }
        })
      }
    } catch (error) {
      console.error("Error during API call:", error);
    } finally {
      setLoading(false);
    }
  };

  // let specifyleadsource = "";
  // if (selectLeadSource.value === "Other") {
  //   specifyleadsource = "other";
  // } else {
  //   specifyleadsource = "";
  // }

  // const handleIconClick = (formId) => {
  //   if (activeForm !== formId) {
  //     setActiveForm(formId);
  //   }
  // };
  const handleIconClick = (formId) => {
    setActiveForm((prevActiveBox) =>
      prevActiveBox === formId ? null : formId
    );
  };

  // const groupValue = groupOptions.length > 0 ? groupOptions[0].value : null;
  const navigate = useNavigate();
  const redirectLeadPage = () => {
    Swal.fire({
      html: '<div style="font-size: 15px;">Do you want to go back to the previous screen?</div>',
      showCancelButton: true,
      confirmButtonText:
        '<span style="font-size: 12px;color:rgb(148,101,170);">YES</span>',
      cancelButtonText:
        '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
      confirmButtonColor: "white",
      cancelButtonColor: "white",
      customClass: {
        popup: "custom-popup",
        confirmButton: "custom-confirm-button",
        cancelButton: "custom-cancel-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/businessLead");
      } else {
        if (leadId) {
          navigate(`/businessLeadForm?LeadId=${leadId}`);
        } else {
          navigate("/businessLeadForm");
        }
      }
    });
  };

  const mobileNo = userLeadData.mobileNo;
  const redirectFLR = () => {
    if (mobileNo) {
      // console.log(leadId)
      navigate(`/flrcreate?LeadId=${leadId}&mobileNo=${mobileNo}`);
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "black",
      color: "white",
      border: "none",
      boxShadow: state.isFocused ? "none" : provided.boxShadow,
      textAlign: "center",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "white",
    }),
    option: (provided, state) => ({
      ...provided,
      // backgroundColor: state.isFocused ? 'blue' : 'black',
      color: "black",
      textAlign: "center",
    }),
  };


  // ==================== SDWAN ===================

useEffect(() => {
  // Replace with your actual API endpoint
  fetch(process.env.REACT_APP_API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      Action: "getVertical",
      Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
      // password: "S@lesperson@20#!24$",
      stateCode: "",
      password: sessionStorage.getItem('password'),
      userName: sessionStorage.getItem('userName'),
      // userName: "salesperson1"
    })
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.Status === "Success") {
        const options = data.Response.Data.map((vertical) => ({
          value: vertical.VerticalId,
          label: vertical.VerticalName
        }));
        setVerticalOptions(options);
      }
    })
    .catch((error) => console.error("Error fetching verticals:", error));
}, []);

// ==================== SDWAN END ===================

  return (
    <>
      {/* ***********Header********* */}
      <div className="container-fluid text-light Header-style header">
        <div className="p-3">
          <span
            className=""
            style={{ cursor: "pointer" }}
            onClick={redirectLeadPage}
          >
            <i className="fa-solid fa-arrow-left-long"></i>
          </span>
          {/* <span className="p-1 m-2">Lead Details</span> */}
          {leadId ? (
            <span className="p-1 m-2">Update Lead</span>
          ) : (
            <span className="p-1 m-2">Lead Details</span>
          )}
          {flrStatus === 0 && status !== "1" && status !== "2" && (
            <span className="flr-createCAf" onClick={redirectFLR}>
              Create FLR
            </span>
          )}
        </div>
      </div>
      {/* ************Header end************ */}

      {loading ? (
        <div className="loader-wrapper">
          <div className="loader">
            <img src={loader} alt="loading...."></img>
          </div>
        </div>
      ) : (
        <div className="container-fluid form-container">
          {(flrStatus == 0 && status !== "1" && status !== "2" && leadId) && (
            <Select
              className="basic-single disqualify-select"
              classNamePrefix="select"
              name="subBusiness"
              // value={selectQualify}
              isSearchable={false}
              styles={customStyles}
              value={{ value: "", label: "Disqualify" }} // Value should be an object with 'value' and 'label' properties
              onChange={handleSelectQualify}
              options={optionQualify.map((data) => ({
                value: data.code,
                label: data.name,
              }))}
            />
          )}

          {status === "0" && flrStatus === 1 ? (
            <button
              className="btn w-100 mt-2 qualify-btn text-light"
              onClick={handleQualifyLead}
            >
              Qualify
            </button>
          ) : (
            ""
          )}
          {/* **************Contact Information toggle******************* */}
          <div
            className="contact-toggle mt-3"
            onClick={() => handleIconClick("form1")}
          >
            <span className="toggle-text">Contact Information</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form1" && (
            <div
              className=" container shadow  mb-3 bg-body rounded mt-4"
              id="form1"
            >
              <form className="lead-form p-2">
                {leadId && (
                  <div
                    className="input-box form-floating"
                    style={{ position: "relative", paddingTop: "4px" }}
                  >
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="leadId"
                      name="leadId"
                      value={leadId}
                      onChange={handleChange}
                      readOnly={true}
                      style={{ background: "transparent" }}
                    />
                    <i
                      className="fa-solid fa-lock text-secondary"
                      style={{
                        position: "absolute",
                        right: "20px",
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                    ></i>
                    <label htmlFor="floatingInput " className="leadId  mt-2">
                      Lead Id
                    </label>
                  </div>
                )}

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="topic"
                    name="topic"
                    value={userLeadData.topic}
                    onChange={handleChange}
                    ref={topicInputRef}
                    required
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Topic*
                  </label>
                </div>

                <div
                  className="input-box form-floating"
                  style={{ position: "relative", paddingTop: "4px" }}
                >
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm busipad"
                    id="Business"
                    name="Business"
                    value="Business"
                    // onChange={handleChange}
                    readOnly={true}
                    style={{ background: "transparent" }}
                  />
                  <i
                    className="fa-solid fa-lock text-secondary"
                    style={{
                      position: "absolute",
                      right: "20px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      marginTop: "2px",
                    }}
                  ></i>
                  <label htmlFor="floatingInput" className="leadId mt-2">
                    Business Segment*
                  </label>
                </div>

                {/* {console.log('selectSubBusiness1 :',selectSubBusiness.value)} */}
                <div className="">
                  <label className="select-search-label mt-1">
                    Sub Business Segment*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="subBusiness"
                    placeholder=""
                    styles={style}
                    value={selectSubBusiness}
                    isSearchable={false}
                    onChange={handleSelectSubBusiness}
                    options={optionSubBusiness.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                {/* {console.log("selectCustomerSeg ",selectCustomerSeg)} */}
                <div className="">
                  <label className="select-search-label mt-1">
                    Customer Segment*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="selectCustomerSeg"
                    placeholder="Select"
                    styles={style}
                    value={selectCustomerSeg}
                    isSearchable={false}
                    onChange={handleSelectCustomerSeg}
                    options={optionCustomerSeg.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                {selectSubBusiness.label === "SDWAN" && (
                <div>
                  <label className="select-search-label mt-1">Vertical*</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="vertical"
                    value={selectedVertical}
                    onChange={setSelectedVertical}
                    options={verticalOptions}
                    styles={style}
                    placeholder="Select Vertical"
                    isSearchable={true}
                  />
                </div>
                )}

                {!leadId && (
                  <div
                    className="input-box form-floating"
                    style={{ position: "relative", paddingTop: "3px" }}
                  >
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="leadId"
                      name="leadId"
                      value={userLeadData.leadId}
                      onChange={handleChange}
                      readOnly={true}
                      style={{ background: "transparent" }}
                    />
                    <i
                      className="fa-solid fa-lock text-secondary"
                      style={{
                        position: "absolute",
                        right: "20px",
                        top: "50%",
                        transform: "translateY(-50%)",
                      }}
                    ></i>
                    <label htmlFor="floatingInput" className="leadId ">
                      Lead Id
                    </label>
                  </div>
                )}

                {/* {console.log("selectSalutation :",selectSalutation.value)} */}
                <div className="">
                  <label className="select-search-label mt-1">Salutation*</label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="subBusiness"
                    placeholder="Select"
                    styles={style}
                    value={selectSalutation}
                    isSearchable={false}
                    onChange={handleSelectSalutation}
                    options={optionSalutation.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="PersonName"
                    name="PersonName"
                    value={userLeadData.PersonName ? userLeadData.PersonName : ""}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Contact Person Name*
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="email"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="email"
                    name="email"
                    value={userLeadData.email}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Email ID*
                  </label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="tel"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="mobileNo"
                    name="mobileNo"
                    maxLength="10"
                    pattern="[0-9]{10}"
                    value={userLeadData.mobileNo}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (
                        (isDigit || allowedKeys.includes(e.key)) &&
                        (userLeadData.mobileNo.length < 10 ||
                          e.key === "Backspace")
                      ) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Mobile No*
                  </label>
                </div>

                {/* {console.log("lead name :",leadName)} */}

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className="form-control input-text form-control-sm mt-1"
                    id="leadName"
                    name="leadName"
                    value={leadName}
                    onChange={(e) => setLeadName(e.target.value)}
                  />
                  <label htmlFor="leadName" className="mt-2">
                    Lead Name*
                  </label>
                </div>

                {/* {console.log("company length :",selectedCompany)} */}
                {/* {console.log("company :",selectedCompany)} */}
                <div className="">
                  <label className="select-search-label mt-1">Company*</label>
                  <Select
                    className=" form-control form-control-sm p-1"
                    id="companySelect"
                    name="company"
                    placeholder="Search Company"
                    value={selectedCompany}
                    styles={style}
                    isLoading={loaders}
                    onChange={(selectedOption) => {
                      handleCompanyChange(selectedOption);
                      (selectedOption.label !== "New Company" && !leadName) && setLeadName(selectedOption.label)
                      setCompanyName(
                        selectedOption &&
                          selectedOption.label !== "New Company"
                          ? selectedOption.label
                          : ""
                      );
                    }}
                    options={companyOptions}
                    isSearchable={true}
                  />
                </div>

                {/* {console.log("groupOptions ",groupOptions)} */}
                <div className="">
                  <label className="select-search-label mt-1">Group*</label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="relationship"
                    placeholder="Select Group"
                    styles={style}
                    // value={groupOptions.length > 0 ? groupOptions[0].value : null}
                    value={selectedGroup}
                    isSearchable={false}
                    onChange={handleSelectGroup}
                    options={groupOptions}
                  />
                </div>

                {/* {console.log("relationship",selectRelationship)} */}
                <div className="">
                  <label className="select-search-label mt-1">
                    Relationship*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm  p-1"
                    classNamePrefix="select"
                    name="relationship"
                    placeholder="Select Relationship"
                    styles={style}
                    value={selectRelationship}
                    isSearchable={false}
                    onChange={handleSelectRelationship}
                    options={relationshipOptions.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

              </form>
            </div>
          )}

          {/* **************Lead Channel & Source toggle******************* */}
          <div
            className="Lead-Channel-toggle mt-3"
            onClick={() => handleIconClick("form2")}
          >
            <span className="toggle-text">Lead Channel & Source</span>
            <span className=" float-end ">
              <i className="fa-solid fa-angle-down fa-lg text-dark down-arrow"></i>
            </span>
          </div>

          {activeForm === "form2" && (
            <div
              className="container shadow mb-3 bg-body rounded mt-4"
              id="form2"
            >
              <form className="Lead-Channel-form p-2">
                {/* {console.log("selectLeadChannel",selectLeadChannel.value)} */}
                <div className="">
                  <label className="select-search-label mt-1">
                    Lead Channel*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="IndustrySeg"
                    placeholder="Select"
                    styles={style}
                    isSearchable={false}
                    value={selectLeadChannel}
                    onChange={handleSelectLeadChannel}
                    options={optionLeadChannel.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                {/* {console.log("leadSourceOptions",leadSourceOptions)} */}
                <div className="">
                  <label className="select-search-label mt-1">
                    Lead Source*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="leadSource"
                    placeholder="Select Lead Source"
                    styles={style}
                    isSearchable={false}
                    value={selectLeadSource}
                    // value={selectLeadSource ? selectLeadSource : ""}
                    onChange={handleSelectLeadSource}
                    options={leadSourceOptions}
                  />
                </div>

                {selectLeadSource && selectLeadSource?.label?.includes("Other") ? (
              <div className="input-box form-floating">
                <input
                  type="text"
                  placeholder=""
                  className=" form-control input-text form-control-sm mt-1"
                  id="specifyLeadSource"
                  name="specifyLeadSource"
                  value={userLeadData.specifyLeadSource}
                  style={{ background: "transparent" }}
                  onChange={handleChange}
                />
                <label htmlFor="floatingInput" className="mt-2">
                  Specify Lead Source
                </label>
              </div>) : null}
                {/* 
                <div className="">
                  <label className="select-search-label mt-1">
                    Channel Partner
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="partner"
                    placeholder=""
                    styles={style}
                    isSearchable={false}
                    value={selectChannelPartner}
                    onChange={handleSelectChannelPartner}
                    options={optionChannelPartner}
                  />
                </div> */}
              </form>
            </div>
          )}

          {/* **************Installation Address toggle******************* */}
          <div
            className="Installation-toggle mt-3"
            onClick={() => handleIconClick("form3")}
          >
            <span className="toggle-text">Installation Address</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form3" && (
            <div
              className="container shadow mb-3 bg-body rounded mt-4"
              id="form3"
            >
              <form className="Installation-form p-2">
                <div className="">
                  <label className="select-search-label mt-1">Country*</label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="IndustrySeg"
                    placeholder="Select Country"
                    styles={style}
                    isSearchable={false}
                    value={{ value: '10001', label: 'India' }}
                    onChange={handleSelectCountry}
                    options={optionCountry.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">State*</label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="IndustrySeg"
                    placeholder="Select State"
                    isSearchable={false}
                    styles={style}
                    value={selectState}
                    onChange={handleSelectState}
                    options={optionState.map((data) => ({
                      value: data.code,
                      label: data.name,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">City*</label>
                  <Select
                    className="basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="City"
                    placeholder="Select City"
                    isSearchable
                    styles={style}
                    // value={cityType.find(
                    //   (city) => city.CityCode === selectCity.value
                    // )}
                    value={selectCity}
                    onChange={handleSelectCity}
                    options={cityType.map((data) => ({
                      value: data.CityCode,
                      label: data.CityName,
                    }))}
                  />
                </div>

                <div className="search-area" style={{ position: "relative" }}>
                  <label className="select-search-label mt-1">Area*</label>
                  <Select
                    options={areaList.map((area) => ({
                      value: area.AreaCode,
                      label: `${area.AreaName} (${area.AreaCode})`,
                    }))}
                    className=" form-control form-control-sm p-1 custom-select"
                    placeholder="Search Area"
                    isSearchable
                    styles={style}
                    value={selectArea}
                    onChange={handleSelectArea}
                  />
                  <i
                    className="fas fa-search text-secondary"
                    style={{
                      position: "absolute",
                      right: "15px",
                      top: "63%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                </div>

                <div className="search-building" style={{ position: "relative" }}>
                  <label className="select-search-label mt-1">Building Name*</label>
                  <Select
                    options={buildingList.map((building) => ({
                      value: building.BuildingCode,
                      label: `${building.BuildingName} (${building.BuildingCode})`,
                    }))}
                    className="form-control form-control-sm p-1 custom-select"
                    placeholder="Search Building"
                    styles={style}
                    isSearchable
                    value={selectBuilding}
                    onChange={(selectedOption) =>
                      setSelectBuilding(selectedOption)
                    }
                  />
                  <i
                    className="fas fa-search text-secondary"
                    style={{
                      position: "absolute",
                      right: "15px",
                      top: "63%",
                      transform: "translateY(-50%)",
                    }}
                  ></i>
                </div>

                <div className="input-box form-floating mt-1">
                  {selectArea && selectArea.label.includes("Other") ? (
                    <>
                      <input
                        type="text"
                        placeholder=""
                        className="form-control input-text form-control-sm"
                        name="specifyArea"
                        value={userLeadData.specifyArea}
                        onChange={handleChange}
                      />
                      <label htmlFor="floatingInput" className="mt-2">Specific Area Name</label>
                    </>
                  ) : null}
                </div>

                <div className="input-box form-floating">
                  {selectBuilding && selectBuilding.label.includes("Other") ? (
                    <>
                      <input
                        type="text"
                        placeholder=""
                        className="form-control input-text form-control-sm mt-1"
                        id="buildingName"
                        name="specifyBuilding"
                        value={userLeadData.specifyBuilding}
                        onChange={handleChange}
                      />
                      <label htmlFor="floatingInput" className="mt-2">
                        Specific Building Name
                      </label>
                    </>
                  ) : null}
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="buildingNum"
                    name="buildingNum"
                    value={userLeadData.buildingNum}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">Building No./Plot No.*</label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="block"
                    name="block"
                    value={userLeadData.block}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">Block*</label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="floor"
                    name="floor"
                    value={userLeadData.floor}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">Floor*</label>
                </div>

                <div className="input-box form-floating">
                  <input
                    type="tel"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="pin"
                    name="pin"
                    maxLength="6"
                    pattern="[0-9]{10}"
                    value={userLeadData.pin}
                    onChange={handleChange}
                    onKeyDown={(e) => {
                      const allowedKeys = [
                        "Backspace",
                        "Delete",
                        "ArrowLeft",
                        "ArrowRight",
                        "Tab",
                      ];
                      const isDigit = /\d/.test(e.key);
                      if (
                        (isDigit || allowedKeys.includes(e.key)) &&
                        (userLeadData.pin.length < 6 || e.key === "Backspace")
                      ) {
                        return true;
                      } else {
                        e.preventDefault();
                      }
                    }}
                  />
                  <label htmlFor="floatingInput" className=" mt-2">Pin Code*</label>
                </div>
              </form>
            </div>
          )}

          {/* **************Contact Person Address toggle******************* */}
          <div
            className="Person-Address-toggle mt-3"
            onClick={() => handleIconClick("form4")}
          >
            <span className="toggle-text">Contact Person Address Details</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form4" && (
            <div className=" container-fluid">
              <div>
                <span>Same as Installation Address</span>
                <span className="" style={{ marginLeft: "40px" }}>
                  <input
                    type="checkbox"
                    checked={useSameData}
                    onChange={handleCheckboxChange}
                  />
                </span>
              </div>
              <div
                className="container shadow mb-3 bg-body rounded mt-4"
                id="form4"
              >
                <form className="Person-Address-form p-2">
                  <div className="">
                    <label className="select-search-label mt-1">Country*</label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="IndustrySeg"
                      placeholder="Select Country"
                      styles={style}
                      isSearchable={false}
                      value={{ value: '10001', label: 'India' }}
                      onChange={handleSelectCountryOne}
                      options={optionCountryOne.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>

                  {/* <div className="">
                  <label className="select-search-label mt-1">State*</label>
                  <Select
                    className=" basic-single form-control p-1"
                    classNamePrefix="select"
                    name="IndustrySeg"
                    placeholder="Select"
                    isSearchable
                    styles={style}
                    value={selectStateOne}
                    onChange={handleSelectStateOne}
                    options={optionState.map((data) => ({
                      value: data.code,
                      label: data.name,
                    }))}
                  />
                </div> */}

                  {/* {console.log("selectStateOne",selectStateOne)} */}
                  <div className="">
                    <label className="select-search-label mt-1">State*</label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="state"
                      placeholder="Select State"
                      isSearchable
                      styles={style}
                      value={selectStateOne}
                      onChange={handleSelectStateOne}
                      options={optionStateOne.map((data) => ({
                        value: data.code,
                        label: data.name,
                      }))}
                    />
                  </div>

                  {/* {console.log("selectCityOne",selectCityOne)} */}
                  <div className="">
                    <label className="select-search-label mt-1">City*</label>
                    <Select
                      className="basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="City"
                      placeholder="Select City"
                      isSearchable
                      styles={style}
                      // value={cityType.find(
                      //   (city) => city.CityCode === selectCityOne.value
                      // )}
                      value={selectCityOne}
                      onChange={handleSelectCityOne}
                      options={cityTypeOne.map((data) => ({
                        value: data.CityCode,
                        label: data.CityName,
                      }))}
                    />
                  </div>

                  <div className="">
                    <label className="select-search-label mt-1">Area*</label>
                    <Select
                      options={areaList.map((area) => ({
                        value: area.AreaCode,
                        label: `${area.AreaName} (${area.AreaCode})`,
                      }))}
                      className=" form-control form-control-sm p-1"
                      placeholder="Search Area"
                      isSearchable
                      styles={style}
                      value={selectAreaOne}
                      onChange={handleSelectAreaOne}
                    />
                    {/* <label htmlFor="floatingSelectArea">Area*</label> */}
                  </div>

                  <div className="">
                    <label className="select-search-label mt-1">Building Name*</label>
                    <Select
                      options={buildingList.map((building) => ({
                        value: building.BuildingCode,
                        label: `${building.BuildingName} (${building.BuildingCode})`,
                      }))}
                      className="form-control form-control-sm p-1"
                      placeholder="Search Building"
                      styles={style}
                      isSearchable
                      value={selectBuildingOne}
                      onChange={(selectedOption) =>
                        setSelectBuildingOne(selectedOption)
                      }
                    />
                  </div>

                  <div className="input-box form-floating">
                    {selectAreaOne && selectAreaOne.label.includes("Other") ? (
                      <>
                        <input
                          type="text"
                          placeholder=""
                          className="form-control input-text form-control-sm mt-1"
                          name="specifyAreaOne"
                          value={userLeadData.specifyAreaOne}
                          onChange={handleChange}
                        />
                        <label htmlFor="floatingInput" className="mt-2">
                          Specific Area Name
                        </label>
                      </>
                    ) : null}
                  </div>

                  <div className="input-box form-floating">
                    {selectBuildingOne &&
                      selectBuildingOne.label.includes("Other") ? (
                      <>
                        <input
                          type="text"
                          placeholder=""
                          className="form-control input-text form-control-sm mt-1"
                          id="buildingName"
                          name="SpecifyBuildingOne"
                          value={userLeadData.specifyBuildingOne}
                          onChange={handleChange}
                        />
                        <label htmlFor="floatingInput" className="mt-2">
                          Specific Building Name
                        </label>
                      </>
                    ) : null}
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="buildingNum"
                      name="buildingNumOne"
                      value={userLeadData.buildingNumOne}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Building No./Plot No.*
                    </label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="block"
                      name="blockOne"
                      value={userLeadData.blockOne}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInput" className="mt-2">Block*</label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="floor"
                      name="floorOne"
                      value={userLeadData.floorOne}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInput" className="mt-2">Floor*</label>
                  </div>

                  <div className="input-box form-floating">
                    <input
                      type="tel"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="pin"
                      name="pinOne"
                      maxLength="6"
                      pattern="[0-9]{10}"
                      value={userLeadData.pinOne}
                      onChange={handleChange}
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ];
                        const isDigit = /\d/.test(e.key);
                        if (
                          (isDigit || allowedKeys.includes(e.key)) &&
                          (userLeadData.pinOne.length < 6 ||
                            e.key === "Backspace")
                        ) {
                          return true;
                        } else {
                          e.preventDefault();
                        }
                      }}
                    />
                    <label htmlFor="floatingInput" className="mt-2">Pin Code*</label>
                  </div>
                </form>
              </div>
            </div>
          )}

          {/* **************Company details toggle******************* */}
          <div
            className="Company-details-toggle mt-3"
            onClick={() => handleIconClick("form5")}
          >
            <span className="toggle-text">Company Details</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form5" && (
            <div
              className="container shadow mb-3 bg-body rounded mt-4"
              id="form5"
            >
              <form className="Company-details-form p-2">
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-2"
                    id="company"
                    name="CompanyName"
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                  />
                  <label htmlFor="floatingInput" className="mt-2">Company Name</label>
                </div>

                <div className="">
                  <label className="select-search-label mt-1">
                    Firm Type*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="firmType"
                    placeholder="Select FirmType"
                    styles={style}
                    value={selectFirmType}
                    isSearchable={false}
                    onChange={handleSelectFirmType}
                    options={firmType.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                {/* {console.log("Industry Type :",selectIndustryType)} */}
                <div className="">
                  <label className="select-search-label mt-1">
                    Industry Type*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="industryType"
                    placeholder="Select IndustryType"
                    styles={style}
                    value={selectIndustryType}
                    isSearchable={false}
                    onChange={handleSelectIndustryType}
                    options={industryTypes.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="jobTitle"
                    name="jobTitle"
                    value={userLeadData.jobTitle}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">Job Title</label>
                </div>
              </form>
            </div>
          )}

          <div
            className="Other-details-toggle mt-3"
            onClick={() => handleIconClick("form6")}
          >
            <span className="toggle-text">Other Details</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form6" && (
            <div
              className="container shadow mb-3 bg-body rounded mt-4"
              id="form6"
            >
              <form className="Other-details-form p-2">
                {/* {console.log(selectProductOption)} */}
                <div className="">
                  <label className="select-search-label mt-1">
                    Product Name*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="product"
                    placeholder="Select Option"
                    styles={style}
                    value={selectProduct}
                    isSearchable={true}
                    onChange={handleSelectproduct}
                    // options={selectProductOption}
                    options={selectProductOption.map((data) => ({
                      value: data.ProductID,
                      label: data.ProductName,
                    }))}
                  />
                </div>

                {/* {console.log("selectMedia",selectMedia)} */}
                <div className="">
                  <label className="select-search-label mt-1">
                    Media*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="media"
                    placeholder="Select"
                    styles={style}
                    value={selectMedia}
                    isSearchable={false}
                    onChange={handleSelectMedia}
                    options={media.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">
                    Existing Service Provider 1*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="service"
                    placeholder="Select Service Provider 1"
                    styles={style}
                    value={selectExServiceProviderOne}
                    isSearchable={false}
                    onChange={handleSelectServiceProviderOne}
                    options={ExServiceProviderOne.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">
                    Existing Service Provider 2*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="service"
                    placeholder="Select Service Provider 2"
                    styles={style}
                    value={selectExServiceProviderTwo}
                    isSearchable={false}
                    onChange={handleSelectServiceProviderTwo}
                    options={ExServiceProviderTwo.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">
                    Current Work Locations*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="service"
                    placeholder="Select City"
                    styles={style}
                    value={selectCurrentWorkLocation}
                    isSearchable={true}
                    onChange={handleCurrentWorkLocation}
                    options={currentWorkLocations.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">
                    Interested in Data Center/Cloud services*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="cloudService"
                    placeholder="Select Option"
                    styles={style}
                    value={selectDataCenter}
                    isSearchable={false}
                    onChange={handleDataCenter}
                    options={optionDataCenter.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">
                    Is Customer interested in firewall*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="firewall"
                    placeholder="Select Option"
                    styles={style}
                    value={selectInterestedFirewall}
                    isSearchable={false}
                    onChange={handleInterestedFirewall}
                    options={optionInterestedFirewall.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">
                    Is Customer interested in VPN services*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="firewall"
                    placeholder="Select Option"
                    styles={style}
                    value={selectInterestedVPN}
                    isSearchable={false}
                    onChange={handleInterestedVPN}
                    options={optionInterestedVPN.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">
                    Services from Services Provider 1*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="firewall"
                    placeholder="Select Existing Service Provider"
                    styles={style}
                    value={selectServiceProviderOne}
                    isSearchable={false}
                    onChange={handleServiceProviderOne}
                    options={optionServiceFromServiceProvider1.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">
                    Services from Services Provider 2*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="firewall"
                    placeholder="Select Existing Service Provider"
                    styles={style}
                    value={selectServiceProviderTwo}
                    isSearchable={false}
                    onChange={handleServiceProviderTwo}
                    options={optionServiceFromServiceProvider2.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>


                <div className="">
                  <label className="select-search-label mt-1">
                    Is Customer Interested in VOIP*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="firewall"
                    placeholder="Select Option"
                    styles={style}
                    value={selectInterestedVOIP}
                    isSearchable={false}
                    onChange={handleInterestedVOIP}
                    options={optionInterestedVOIP.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                <div className="">
                  <label className="select-search-label mt-1">
                    Is Customer Interested in Managed Wi-Fi*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="wifi"
                    placeholder="Select Option"
                    styles={style}
                    value={selectInterestedManageWiFi}
                    isSearchable={false}
                    onChange={handleInterestedManageWiFi}
                    options={optionInterestedManageWiFi.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>


                {/* {console.log("targetInstallationPeriod",userLeadData.targetInstallationPeriod)} */}
                <div className="input-box form-floating p-0">
                  <input
                    type="date"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="targetInstallationPeriod"
                    name="targetInstallationPeriod"
                    value={formatDateString(
                      userLeadData.targetInstallationPeriod
                    )}
                    onChange={handleChange}
                    min={getCurrentDate()}
                  />
                  <label htmlFor="floatingInput" className="mt-2">
                    Target Installation Period*
                  </label>
                </div>

                {/* <div className="form-floating p-1">
                  <select
                    className="form-select form-control form-control-sm"
                    id="floatingSelect"
                    aria-label="Floating label select example"
                    name="firewall"
                    value={selectFirewall}
                    onChange={handleFirewall}
                  >
                    {optionFirewall.map((data, index) => {
                      return (
                        <option className="" value={data.value} key={index}>
                          {data.Firewall}
                        </option>
                      );
                    })}
                  </select>
                  <label htmlFor="floatingSelect">
                    Is Customer Using firewall*
                  </label>
                </div> */}

                {/* {console.log("selectFirewall",selectFirewall.value)} */}
                <div className="">
                  <label className="select-search-label mt-1">
                    Is Customer Using firewall*
                  </label>
                  <Select
                    className=" basic-single form-control form-control-sm p-1"
                    classNamePrefix="select"
                    name="firewall"
                    placeholder="Select Option"
                    styles={style}
                    value={selectFirewall}
                    isSearchable={false}
                    onChange={handleFirewall}
                    options={optionFirewall.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                  />
                </div>

                {selectFirewall.value && selectFirewall.value === "True" ? (
                  <div className="">
                    <label className="select-search-label mt-1">
                      Is It a multilocation Customer*
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="firewall"
                      placeholder="Select Option"
                      styles={style}
                      value={selectIsMultilocationCust}
                      isSearchable={false}
                      onChange={handleIsMultilocationCust}
                      options={optionIsMultilocationCust.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>
                ) : null}

                {selectFirewall.value && selectFirewall.value === "True" ? (
                  <div className="input-box form-floating">
                    <input
                      type="tel"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="howManyLocations"
                      name="howManyLocations"
                      // maxLength="10"
                      pattern="[0-9]{10}"
                      value={userLeadData.howManyLocations}
                      onChange={handleChange}
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ];
                        const isDigit = /\d/.test(e.key);
                        if (isDigit || allowedKeys.includes(e.key)) {
                          return true;
                        } else {
                          e.preventDefault();
                        }
                      }}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Customer Using firewall at how many locations*
                    </label>
                  </div>
                ) : null}

                {selectFirewall.value && selectFirewall.value === "True" ? (
                  <div className="">
                    <label className="select-search-label mt-1">
                      Payment Mode*
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="firewall"
                      placeholder="Select Option"
                      styles={style}
                      value={selectPaymentMode}
                      isSearchable={false}
                      onChange={handleSelectPaymentMode}
                      options={optionPaymentMode.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>
                ) : null}

                {selectFirewall.value &&
                  selectFirewall.value === "True" &&
                  selectPaymentMode.value &&
                  selectPaymentMode.value === "Capex" ? (
                  <div className="input-box form-floating p-1">
                    <input
                      type="tel"
                      placeholder=""
                      className=" form-control input-text form-control-sm"
                      id="actualContract"
                      name="actualContract"
                      // maxLength="10"
                      pattern="[0-9]{10}"
                      value={userLeadData.actualContract}
                      onChange={handleChange}
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ];
                        const isDigit = /\d/.test(e.key);
                        if (isDigit || allowedKeys.includes(e.key)) {
                          return true;
                        } else {
                          e.preventDefault();
                        }
                      }}
                    />
                    <label htmlFor="floatingInput">
                      Annual Contact Value (ARC)*
                    </label>
                  </div>
                ) : null}

                {selectFirewall.value && selectFirewall.value === "True" ? (
                  <div className="">
                    <label className="select-search-label mt-1">
                      Existing Service Provider(Infra)*
                    </label>
                    <Select
                      className=" basic-single form-control form-control-sm p-1"
                      classNamePrefix="select"
                      name="firewall"
                      placeholder="Select Option"
                      styles={style}
                      value={selectExistingServProvInfra}
                      isSearchable={false}
                      onChange={handleExistingServProvInfra}
                      options={optionExistingServProvInfra.map((data) => ({
                        value: data.value,
                        label: data.label,
                      }))}
                    />
                  </div>
                ) : null}

                {selectFirewall.value && selectFirewall.value === "True" ? (
                  <div className="input-box form-floating">
                    <input
                      type="text"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="detailServProvInfra"
                      name="detailServProvInfra"
                      value={userLeadData.detailServProvInfra}
                      onChange={handleChange}
                    />
                    <label htmlFor="floatingInput" className="mt-2">
                      Details of Service Provider (Infra)*
                    </label>
                  </div>
                ) : null}

                {selectFirewall.value && selectFirewall.value === "True" ? (
                  <div className="input-box form-floating p-0">
                    <input
                      type="date"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="contractExpDate"
                      name="contractExpDate"
                      value={formatDateString(userLeadData.contractExpDate)}
                      onChange={handleChange}
                      min={getCurrentDate()}
                    />
                    <label htmlFor="floatingInput" className="p-2">
                      Contact Expiry date*
                    </label>
                  </div>
                ) : null}

                {selectPaymentMode.value && selectPaymentMode.value === "Opex" ? (
                  <div className="input-box form-floating">
                    <input
                      type="tel"
                      placeholder=""
                      className=" form-control input-text form-control-sm mt-1"
                      id="firewall"
                      name="firewall"
                      // maxLength="10"
                      pattern="[0-9]{10}"
                      value={userLeadData.onFirewall}
                      onChange={handleChange}
                      onKeyDown={(e) => {
                        const allowedKeys = [
                          "Backspace",
                          "Delete",
                          "ArrowLeft",
                          "ArrowRight",
                          "Tab",
                        ];
                        const isDigit = /\d/.test(e.key);
                        if (isDigit || allowedKeys.includes(e.key)) {
                          return true;
                        } else {
                          e.preventDefault();
                        }
                      }}
                    />

                    <label htmlFor="floatingInput" className="mt-2">
                      Current Monthly Spend on Firewall(MRC)*
                    </label>
                  </div>
                ) : null}
              </form>
            </div>
          )}

          <div
            className="Remarks-toggle mt-3"
            onClick={() => handleIconClick("form7")}
          >
            <span className="toggle-text">Remarks</span>
            <span className=" float-end">
              <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
            </span>
          </div>

          {activeForm === "form7" && (
            <div
              className="container shadow mb-3 bg-body rounded mt-4"
              id="form7"
            >
              <form className="Remarks-form p-2">
                <div className="input-box form-floating">
                  <input
                    type="text"
                    placeholder=""
                    className=" form-control input-text form-control-sm mt-1"
                    id="remark"
                    name="remark"
                    value={userLeadData.remark}
                    onChange={handleChange}
                  />
                  <label htmlFor="floatingInput" className="mt-2">Remarks</label>
                </div>
              </form>
            </div>
          )}

          <div className=" text-center mt-5 mb-3">
            <button
              type="submit"
              className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
              onClick={handleSubmit}
            >
              Save
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default LeadDetailsForm;
